import webinarImage from "../../src/images/business-case-for-microsegmentation/webinarBanner.png"
import linkdinImage from "../../src/images/zero-trust-architecture/linkdinImage.webp"
import stepImage from "../../src/images/zero-trust-architecture/stepsImage.webp"
import protectionImage from "../../src/images/networkProtection.png"
import ceoImage from "../../src/images/ceo-blog-content-Img.jpeg"
import digitalImage from "../../src/images/purdue-model-Img.png"

// Home page
import BannerLogo from "../../src/images/netspy-logo.svg"
import Gartner from "../../src/images/updateui/gartner-logo.png"

import SayImg1 from "../../src/images/updateui/ot_card_1.jpg"
import SayImg3 from "../../src/images/updateui/Healthcare.webp"
import SayImg4 from "../../src/images/updateui/Transportation.webp"
import SayImg5 from "../../src/images/updateui/Energy.webp"

import Resource1 from "../../src/images/updateui/CEO-BLOG-SERIES.jpeg"
import UpdatedThreatGPT from "../../src/images/updated-Img.svg"

import CustomerResultCard1 from "../../src/images/updateui/kcasLogo.png"
import CustomerResultCard2 from "../../src/images/home-skyline.svg"

import OTCard1 from "../../src/images/updateui/ot_card_1.png"
import OTCard2 from "../../src/images/updateui/ot_card_2.png"
import OTCard3 from "../../src/images/updateui/ot_card_3.png"

import StepImg1 from "../../src/images/updateui/as_2.png"
import StepImg2 from "../../src/images/updateui/as_3.png"
import StepImg4 from "../../src/images/updateui/as_5.png"
import StepImg5 from "../../src/images/updateui/Black.png"

// Platform page
import icon1 from "../../src/images/hospital/icon1.svg"
import icon2 from "../../src/images/hospital/icon2.svg"
import icon3 from "../../src/images/hospital/icon3.svg"

import Operational1 from "../../src/images/updateui/operational-img-1.png"
import Operational2 from "../../src/images/updateui/threatGPT.png"
import Operational3 from "../../src/images/updateui/operational-img-3.png"

import Compliance1 from "../../src/images/updateui/FedRAMP.png"
import Compliance2 from "../../src/images/updateui/hipaa.png"
import Compliance3 from "../../src/images/updateui/nist.png"
import Compliance4 from "../../src/images/updateui/fisma.png"
import Compliance5 from "../../src/images/updateui/iso.png"
import Compliance6 from "../../src/images/updateui/pngwing.png"
import Compliance7 from "../../src/images/updateui/gdpr.png"
import Compliance8 from "../../src/images/updateui/mitre.png"

// Integrations Page
import PartnerIcon1 from "../../src/images/amazon.svg"
import PartnerIcon2 from "../../src/images/azure.png"
import PartnerIcon3 from "../../src/images/googleCloud.png"

import Icon1 from "../../src/images/sentinelOne.png"
import Icon2 from "../../src/images/crowdStrike.png"
import Icon3 from "../../src/images/splunk1.svg"
import Icon4 from "../../src/images/zscaler.png"
import Icon5 from "../../src/images/okta.png"
import Icon6 from "../../src/images/stack.png"
import Icon7 from "../../src/images/armis.png"
import Icon8 from "../../src/images/pagerduty.png"
import Icon9 from "../../src/images/serviveNow1.svg"
import Icon10 from "../../src/images/entra.svg"
import Icon11 from "../../src/images/onelogin.svg"
import Icon12 from "../../src/images/azure_ad.png"

// Case Study Page
import MachineLogo from "../../src/images/machine-device.svg"
import Plus from "../../src/images/plus-icon.svg"

// Agentless microsegmentation page
import logo1 from "../../src/images/hospital/icon1.svg"
import logo2 from "../../src/images/hospital/icon2.svg"
import logo3 from "../../src/images/hospital/icon3.svg"
import logo4 from "../../src/images/hospital/iocn4.svg"

// Threat Intelligence page
import section6 from "../../src/images/updateui/threat-operational-img.svg"
import section7 from "../../src/images/hospital/gpt3.png"

// Manufacturing page
import hsptlsection6 from "../../src/images/hospital/section6.png"
import hsptlsection7 from "../../src/images/industries-Img.svg"

// Company Logos
import Compnay1 from "../../src/images/updateui/c1_1.png"
import Compnay3 from "../../src/images/updateui/c1_3.png"
import Compnay4 from "../../src/images/updateui/c1_4.png"
import Compnay6 from "../../src/images/updateui/c1_6.png"
import Compnay7 from "../../src/images/awfis.png"
import Compnay9 from "../../src/images/updateui/kingston-logo.svg"
import Compnay10 from "../../src/images/updateui/flex-logo.svg"
import Compnay11 from "../../src/images/dropbox.png"

// blog
import BlogCard1 from "../../src/images/CEO-Blog-Img.webp"
import BlogCard2 from "../../src/images/Business-Blog-Image.webp"
import BlogCard3 from "../../src/images/CEO-Series-Blog-Image.webp"
import BlogCard4 from "../../src/images/Prediction-Blog-Image.png"
import BlogCard5 from "../../src/images/Manufacture-Blog-Image.png"
import BlogCard6 from "../../src/images/Core-Blog-Image.png"
import BlogCard7 from "../../src/images/patent_9.jpg"


// About investors
import engineeringCapital from "../../src/images/aboutus/engineering capital.png"
import cervin from "../../src/images/cervin-logo.png"
import sorenson from "../../src/images/aboutus/soreson-logo.png"
import aspenwood from "../../src/images/aspen-logo.svg"
import storm from "../../src/images/aboutus/stormvc.png"

// resources solution briefs
import Logo3 from "../../src/images/ransomware_logo.jpg"
import LogoDsj from "../../src/images/DSJ_SB.jpeg"
import LogoNetAi from "../../src/images/NET-AI-PDF.jpg"
import LogoDiscovery from "../../src/images/discovery-visibility.jpg"
import LogoZerotrust from "../../src/images/airgap-zero-trust.jpg"

// resources solution briefs pdf links
import Ransomware from "../../src/PDF/solution-briefs/Ransomware-Kill-Switch-2023.pdf"
import DiscoveryVisibility from "../../src/PDF/solution-briefs/Discovery-and-Visibility.pdf"
import LogoZerotrustPdf from "../../src/PDF/solution-briefs/Airgap-Zero-Trust Enterprise.pdf"


// resources case study
import Logo5 from "../../src/images/updateui/tillysPdf.png"
import Logo6 from "../../src/images/updateui/skylinePdf.png"
import KcasLogo from "../../src/images/updateui/kcasLogo.png"
import logo9 from "../../src/images/cloud_saas_casestudy.svg"
import logo10 from "../../src/images/retail_clothing_casestudy.svg"


// resources case study pdf links
import tillysPdf from "../../src/images/Case-Study-Tillys.pdf"
import AcctonPdf from "../../src/images/Case-Study-Skyline-Enterprises.pdf"
import GlobalCloudPdf from "../../src/PDF/case-study/Case-Study-Global-cloud-storage.pdf"
import GlobalClothingPdf from "../../src/PDF/case-study/Case-Study-Global-clothing-retailer.pdf"

import dsjPdf from "../../src/PDF/solution-briefs/Disposable-Jump-Box-2023.pdf"
import networkAiPdf from "../../src/PDF/solution-briefs/NetworkAi-Solution-brief.pdf"

import flexCaseStudyLogo from "../../src/images/flex-casestudy-cover.svg"

import ventureBeatLogo from "../../src/images/venturebeat-logo.png"
import icnLogo from "../../src/images/icn-logo.png"
import forbesLogo from "../../src/images/forbes-logo.png"
import networkWorld from "../../src/images/network-world.svg"
import darkreadinglogo from "../../src/images/dark-reading-logo.svg"

import tillysVideo from "../../src/videos/tillys_video_testimonial.mp4"
import FlexVideoUrl from "../../src/videos/flex_video_testimonial.mp4"
import HealthcareIndustry from "../../src/videos/kcas_video_testimonial.mp4"
import ceoInterviewUrl from "../../src/videos/ritesh_ceo_interview.mp4"


export const webinarData = [
  {
    para:
      "Getting zero trust strong needs to start by applying microsegmentation to every network endpoint at scale, reducing cyberattackers' ability to move laterally across a network, and stopping breaches before they happen.Think of zero trust as the fitness plan your business needs to get stronger. The goal is to be strong enough to protect operations from disruption, increasing network reliability and efficiency while reducing operating costs. Taking on the challenge of getting microsegmentation right is where to start. Like zero trust, microsegmentation implementations don’t have to be complex and costly to be effective.What’s essential is developing a mindset that a breach will happen. It’s not a matter of if one will; it’s a question of when. CISOs tell me that mindset is essential to getting their zero-trust frameworks in place and excelling at microsegmentation. Making microsegmentation part of the muscle memory of any organization is essential to becoming stronger at zero trust and is a key part of any cybersecurity fitness plan.",
    link: "https://go.airgap.io/on-demand-webinar-faster-zt-microsegmentation",
    img: webinarImage,
  },
]

export const zeroTrustData = [
  {
    heading: "Microsegmentation Needs To Drive Zero Trust",
    para:
      "At the core of any successful zero-trust strategic initiative is ensuring least privileged access is achieved on every device, endpoint, and identity, whether human or machine. Microsegmentation is core to zero trust because it’s designed to isolate identities into segments, regardless of their origin. By treating every identity’s endpoint as a separate micro-segment as Airgap’s Zero Trust Everywhere solution does, granular context-based policy enforcement for every attack surface and endpoint is achieved, killing any chance of lateral movement through the network. AirGaps’ Trust Anywhere architecture also includes an Autonomous Policy Network that scales microsegmentation policies network-wide immediately.AirGap’s unique approach has captured why microsegmentation is included in the definitive standard for zero trust from the National Institute of Standards (NIST). Their Zero Trust Architecture Guidelines NIST SP, 800-207, underscore the critical role of microsegmentation in attaining zero trust compliance corporate-wide.Microsegmentation techniques are also pivotal in stopping and containing intrusion attempts. Forrester’s Trusting Zero Trust study found that 75% of CISO- and director-level leaders consider microsegmentation a key technology foundation for achieving their zero-trust strategic initiatives and are seeing results from their investments. Ponemon Institute’s 2022 report, Managing Risks & Costs At The Edge, found that 54% of organizations have had an average of five attacks on their endpoints in the past year. The annual cost of these annual attacks is $1.8 million or $360,000 per attack. Microsegmentation is proving its value by stopping intrusions and breaches.",
  },
  {
    heading: "Building A Business Case For Microsegmentation",
    para:
      "A strong business case for microsegmentation is essential for organizations to keep pursuing and achieving their zero-trust initiatives and goals. By comparing benefits and costs, it’s possible to define the Return on Investment (ROI) of investing in microsegmentation that fits a given business's specific, unique needs. This section intends to provide a baseline framework for assessing benefits versus costs to calculate the ROI of investing in microsegmentation.Figures used in these examples are from interviews with CISOs of mid-size and large-scale enterprises who requested anonymity, given the confidential nature of the data. They are real-world examples of microsegmentation making a difference in operating costs while reducing risks.The following are the benefits that need to be included in a business case for microsegmentation:",
  },
]

export const lists = [
  {
    droplist:
      "Not requiring frequent software agent updates on endpoints reduces IT Help Desk time and costs. ",
    list_text:
      "When CISOs were asked how much they would save if they didn’t have to install and support updates to endpoint software, they said it would easily save 1,250 hours a year of Help Desk time. They also said there are inevitable software conflicts on endpoints that cost more time to troubleshoot and solve. Total wasted time on IT Help Desks from keeping endpoint software current, and conflict-free with other agents is 1,500 hours a year on average. A fully burdened cost per hour of $125 saves $187,000 a year in a company with just over 1,000 employees.",
  },
  {
    droplist:
      "Improving network visibility and control and securing asset access using Multi-Factor Authentication (MFA) and Single Sign-On (SSO) averted several ransomware attacks for a financial services firm. ",
    list_text:
      "The average cost of a single breach is $360,000 based on Ponemon’s latest study, making just the primary costs of seven breaches $2.5 million. CISOs who spoke anonymously say they know of several major ransomware attacks in the last year aimed at their organizations. Total benefit of repelling ransomware attacks microsegmentation to the endpoint level is $2.5 million. For this analysis, assembling a micro-segmented endpoint that will block at least one ransomware attack is reasonable, making the baseline benefit value $360,000.",
  },
  {
    droplist:
      "No more firefighting intrusion attempts using trial-and-error techniques that bring cybersecurity and IT teams in over weekends and holidays at overtime rates. ",
    list_text:
      "CISOs say playing whack-a-mole with intrusion and breach attempts and then trying to remove the ransomware code that’s successfully infiltrated their networks burns their teams out. One CISO of a cloud-based enterprise software provider said to have teams working seven days a week to solve breaches. CISOs say they’re losing employees, which also drains productivity. Overtime salary and material costs for a CISO supporting a 1,000-person company average 850 hours per incident at a fully burdened hourly cost of $125, costing $106,250. Microsgementing every endpoint using a DHCP-enabled gateway, as Air Gaps’ Zero Trust Anywhere solution does, would alleviate this cost.",
  },
  {
    droplist:
      "Eliminating network zones is no longer needed, reducing hardware, software, and services licensing and maintenance costs. ",
    list_text:
      "CISOs said that microsegmentation helps identify which network zones are the most underutilized and contributing to delays. Eliminating network zones, not in use lowers software licensing and maintenance contracts. For the CISO of an organization with 300 employees, he says that microsegmentation helped identify 15 no longer needed zones. Each zone was burning $3,600 a year in hardware, software, and licensing fees, all of which could be saved by eliminating the endpoints in those no longer needed. Total savings from eliminating 15 zones no longer needed is $54,000 annually.",
  },
  {
    droplist:
      "Reducing the risk of fines and regulatory action by enforcing security controls consistently. ",
    list_text:
      "Microsegmentation helps reduce compliance costs by making it easier to implement and enforce security controls required by regulatory and industry compliance standards. For example, the Health Insurance Portability and Accountability Act (HIPAA) requires healthcare organizations to maintain consistent security standards across their networks to protect the confidentiality, integrity, and availability of protected health information (PHI). Tier 1 HIPAA fines start at $10,000 per violation, with an annual maximum of $50,000, and Tier 2 is $50,000 per violation, with an annual maximum of $1.5 million. Legal costs to contest a data security violation can average $25,000 in legal fees alone.",
  },
]

export const caseData = [
  {
    heading: "Creating A Compelling Business Case For Microsegmentation",
    text:
      "The following are the microsegmentation costs that need to be included in the business case:",
    droplist: [
      {
        listHeading:
          "Annual, often multi-year microsegmentation licensing costs. ",
        listText:
          "Microsegmentation providers vary in their pricing models, costs, and fees. Subscription fees of $50,000 a year are assumed for this analysis.",
      },
      {
        listHeading:
          "Change management, implementation, and integration costs increase with IT security, Operations, and IT Service Management (ITSM) integration complexity. ",
        listText:
          "Expect an average price of between $40K to over $100K to integrate microsegmentation with the current security stack, including security information and event management (SIEM) systems.",
      },
    ],
    caseText:
      "The best microsegmentation business cases provide a 360-degree view of costs, benefits, and why taking action now is needed.Knowing the initial software and services costs to acquire and integrate microsegmentation across an organization. CISOs say they’ve doubled down on training, change management, and ongoing support costs to ensure successful implementation.Many include the following equation to provide an ROI estimate in their business cases. The Return on Investment (ROI) for the microsegmentation initiative is calculated as follows:",
  },
]

export const tableData = [
  {
    columnText: "Microsegmentation Benefit",
    columnDollar: "Savings Per Year",
  },
  {
    columnText:
      "Not requiring software agents on endpoints reduces IT Help Desk time and costs.",
    columnDollar: "$187,000",
  },
  {
    columnText:
      "Improving network visibility and control and securing asset access using Multi-Factor Authentication (MFA) and Single Sign-On (SSO).",
    columnDollar: "$360,000",
  },
  {
    columnText:
      "No more firefighting intrusion attempts using trial-and-error techniques that bring cybersecurity and IT teams in over weekends and holidays at overtime rates.",
    columnDollar: "$106,250",
  },
  {
    columnText:
      "Eliminating network zones and reducing hardware, software, and services licensing and maintenance costs.",
    columnDollar: "$54,000",
  },
  {
    columnText:
      "Reducing the risk of fines and regulatory action by enforcing security controls consistently (starting with legal fees to contest a HIPAA violation)",
    columnDollar: "$25,000",
  },
  {
    columnText:
      "Value Of Microsegmentation Benefits Based On CISO’s Cost Estimates",
    columnDollar: "$732,250",
  },
]

export const basedcontent = [
  {
    contentPara:
      "Based on CISOs’ cost estimates of microsegmentation having the potential to save $732,250 a year and the assumption of AirGap’s Zero Trust Everywhere solution costing $150,000 a year, investing in microsegmentation will yield a return of $3.88 for every dollar invested. Additional factors to keep in mind when building a business case for microsegmentation :",
    contentList:
      "Microsegmentation ROI estimates fluctuate, and it's best to get started with a pilot to capture live data with budgets available at the end of a quarter. ",
    contentText:
      "Typically, organizations will allocate the remaining IT security budgets at the end of a quarter, which is an excellent time to ask for a budget for a microsegmentation pilot.",
    contentParalist:
      "Define and measure microsegmentation initiatives' progress using a digitally-enabled dashboard that can be shared across any device, anytime. ",
    contentParaText:
      "Enabling everyone supporting and involved in microsegmentation and zero trust initiatives needs to know what success looks like. A digitally-enabled dashboard that clearly shows each goal or objective and the company's progress toward them is critical to success. AirGaps’ centralized cloud-delivered management and analytics can help.",
    basedList: "Bottom Line: ",
    basedText:
      "CISOs say microsegmentation can pay for itself within months of successfully defending against breaches, and based on their cost estimates, every dollar spent yields $3.88 in value.",
  },
]

export const linkdinData = [
  {
    heading:
      "Resolve To Get in Zero Trust Shape in 2023 Resolve To Be Stronger At Zero Trust",
    para:
      "Resolve to be stronger in the face of more severe, malicious attacks coming in 2023 by segmenting networks now to reduce collateral damage and attackers’ lateral movement. Hardening legacy tech stacks alone doesn’t go far enough to stop and contain ransomware and malware-less attacks.Pursuing a zero trust security strategy starting with microsegmentation does. It’s also core to pursuing a zero trust initiative as defined in the NIST SP 800-207 Zero Trust framework. Microsegmentation has proven effective in eliminating lateral movement across networks and reducing the total attack surface of an organization.Having a breach mindset is key to getting stronger at zero trust. Assuming intrusion and breach attempts are inevitable is a strong motivator for IT and cybersecurity teams to sharpen their zero-trust security strategies, skills, and knowledge.The goal is to make zero trust an integral part of an organization’s muscle memory. The best way to accomplish that is by resolving to get zero-trust initiatives and strategies in shape.",
    img: linkdinImage,
  },
]

export const getStronger = [
  {
    para:
      "Getting stronger at zero trust doesn’t just happen. There needs to be a plan for how, where, and what needs to become strongest first. Nearly every CISO tells me that endpoints are the weakest link in their networks. Attackers capitalize on the weakest endpoints they discover by scanning network ports to gain access and move laterally across networks. As one CISO told me, “there’s good-enough security in legacy systems that we patch, and then there’s zero trust strong, where we’ve taken more control of our attack surfaces and endpoints and know we’re shutting down intrusions.”",
    heading: "How To Become Zero Trust Strong Starts With Microsegmentation ",
    textPara:
      "Defining your fitness program to become stronger at zero trust needs to start with the weakest security areas to turn them into strengths. Fencing endpoints using outdated technology is a weakness that needs to be turned into a strength. Microsegmentation doesn’t need to be complex or expensive to get right.Airgap Networks implemented microsegmentation for a leading specialty retailer of casual apparel, operating hundreds of stores in across the nation. The customer's zero trust requirements included achieving more granular segmentation for IT compliance and enabling Single Sign-On (SSO)/Multi-factor Authentication (MFA) for mission-critical assets across their hybrid workforce and external partners. The customer also needed to accelerate its zero trust deployments and policy management. Most importantly, the customer wanted greater visibility and control of lateral traffic across 100% of their constantly changing endpoint footprints.Airgap’s Zero Trust Everywhere solution is a perfect fit for the customer because it quickly addresses the security areas they need to turn into strengths. Foremost among those is the constantly changing endpoints that together comprise the most fluid attack surfaces the company has. AirGap now has 100% of the customer's corporate endpoints across their data center, corporate headquarters, and retail stores fully microsegmented, along with fully implemented Zero Trust Network Access (ZTNA) for their hybrid workforce and partners.",
  },
  {
    img: stepImage,
    para:
      "Airgap Everywhere is built using standards-based technology that is 100% compatible with an enterprise’s existing tech stack footprint. No agents or network changes are needed.",
    heading: "CISO’s Microsegmentation Lessons Learned",
    textPara:
      "Cybersecurity is now a business decision, and every project needs to deliver value beyond deterrence to protect customer, employee, and partner identities, data, and transactions. CISOs tell me they defend zero trust budgets by showing what will happen to customers, employees, and company revenue if the attack surface isn’t reduced and identities aren‘t protected. CEOs and boards of directors are concerned about the impact of a breach on their brands – and the loss of customer trust during these turbulent economic times.Getting zero trust strong is the way through these challenges, according to CISOs. How they’re getting in zero trust shape is as varied as their businesses are. Yet they all share an intensity to improve zero trust security, tackling microsegmentation early.Here are their lessons learned:",
  },
]

export const platform = [
  {
    heading:
      "Choose a microsegmentation platform that can scale to secure on-premise and cloud components of your security tech stack at scale. ",
    para:
      " A few of the CISOs I’ve spoken with say that one of the challenges they’ve faced implementing microsegmentation is protecting on-premise and cloud apps and platforms. For many organizations, hybrid cloud, multicloud and private cloud configurations typify their IT infrastructures. Airgap’s Zero Trust Everywhere is born in the cloud, can protect hybrid and multicloud configurations, and can be part of an organization’s playbook for managing least privileged access and ZTNA permissions network-wide.",
  },
  {
    heading:
      "Overburdening endpoints with agents leaves them more vulnerable to scans and attacks, while Airgap achieves zero trust using network gateways. ",
    para:
      "One CISO told me they have an average of eleven agents on every endpoint device on their network. Attackers scan their endpoints, looking for software conflicts and breakdowns in coverage. Multiple intrusion attempts happen every week on their overcrowded endpoints as a result. Instead of doubling down on more agents, the CISO spoke to Airgap about how they could reduce their attack surface. Airgap Zero Trust Everywhere makes sense for them because our solution modifies the subnet mask of Dynamic Host ConfigurationProtocol (DHCP) and assumes the role of the default gateway for all devices, regardless of location. That’s much more efficient than retrofitting entire inventories of devices across their global network and more cost-effective.",
  },
  {
    heading:
      "Don’t allow microsegmentation to get stalled as a project; go after zero trust wins at the network level. ",
    para:
      "Mapping application workflows and defining the many integration points across the hundreds of enterprise apps a typical organization relies on is where microsegmentation pilots lose momentum. Gartner VP Analyst Andrew Lerner writes that “network segmentation projects last longer than CISOs” in his blog post on network segmentation. Airgap is designed to scale at speed across enterprises by following the model of telco subscriber networks where breaches are rare and global scale is designed in at the network level at a very low cost. Air gapping every endpoint brings enterprises zero trust across their inventory of IT, OT, and IoT devices, drastically reducing their attack surfaces.",
  },
  {
    heading: "Conclusion",
    para:
      "Don’t be satisfied having cybersecurity in passable shape; resolve to get it in zero trust shape. Simply put, that means implementing least-privileged access, protecting identities as the new security parameter, and, most importantly, reducing attack surfaces using microsegmentation.The cornerstone of zero trust is based on assuming all entities are untrusted by default, least privilege access is enforced on every resource and identity, and comprehensive security monitoring is implemented. The bottom line is that microsegmentation, like zero trust, doesn’t need to be expensive or complex to be effective.   ",
  },
]

export const predictionData = [
  {
    heading:
      "Ten Predictions on the future of Zero Trust and Microsegmentation in 2023",
    text:
      "The bottom line is that simplifying cybersecurity to gain more speed has the potential to stop more breaches this year than the most advanced technologies do. That's the key takeaway from my conversations with CISOs and CIOs, who are pursuing a consolidation strategy regarding their cybersecurity tech stacks. There's no choice but to simplify tech stacks to gain more speed and get the most value from the real-time telemetry data and various alerts they're capturing today.When CISOs and CIOs talk about getting zero trust strong and improving the health and fitness of their cybersecurity tech stack, they're looking to speed up progress on microsegmentation as core to their ZTNA (Zero Trust Network Access) strategic goals first. PwC's 2023 Global Digital Trust Insights Report illustrates their point, with 75% of security leaders saying there is too much complexity in their cybersecurity systems and stacks. Meanwhile, spending continues to soar for information security and risk management solutions, with Gartner predicting the market will increase from $167.86 billion last year to $261.48 billion in 2026, achieving a CAGR of 11.1%. Simplifying cybersecurity tech stacks to gain speed and insight, starting with microsegmentation and zero trust, will make every dollar spent deliver more value.",
  },
  {
    heading: "CISOs Pursuing Simplicity For More Speed",
    text:
      "2023 will be the year cybersecurity gets simplified for speed. CISOs and CIOs spoke with recently confirmed they're backing away from lengthy implementations that will take them into the 3rd or 4th calendar quarter. Everyone I've spoken with is getting obsessed with quick wins and results, especially when it comes to microsegmentation. This year will be one of zero trust, and microsegmentation earns its way into budgets by delivering value quickly – even in proof of concept phases – and locking in budgets that won't be touched. CISOs are also successfully showing how endpoint security and microsegmentation improvements protect revenue.",
  },
]

export const pursingData = [
  {
    para:
      "The following are ten predictions on the future of zero trust and microsegmentation in 2023:",
    dropList: [
      {
        listHeading:
          "CISOs will push to consolidate cybersecurity tech stacks faster in 2023. ",
        listText:
          "Cybersecurity tech stacks are poised to become more consolidated with the continued improvement in endpoint detection and response, microsegmentation, and security intelligence applications combining features. As enterprises move their workloads to the cloud, the need for separate security products disappears. This is leading to a more streamlined approach to general zero-trust security and microsegmentation.",
      },
      {
        listHeading:
          "Quicker implementation times become table stakes on zero trust. ",
        listText:
          "As the need for faster security implementations increases, cloud-based zero trust and microsegmentation platforms will be able to adapt rapidly. CISOs are already relying on automated processes to deploy zero trust and microsegmentation solutions, providing them with the necessary security capabilities quicker and at scale.",
      },
      {
        listHeading:
          "Reducing threat surfaces by using microsegmentation down to the device and sensor levels gain momentum. ",
        listText:
          "More enterprises will use microsegmentation down to the device level, especially in IoTM-centric networks that are unprotected today. By leading their ZTNA strategic initiatives with microsegmentation first, CISOs will trim legacy perimeter-based endpoint systems from their tech stacks and budgets. Microsegmentation will help consolidate tech stacks by reducing threat surfaces faster than the effort-intensive effort that requires an endpoint agent on every device. By segmenting their networks into smaller sections and implementing authorization controls, enterprises can limit the potential areas in which malicious actors can attack.",
      },
      {
        listHeading:
          "AI and machine learning (ML) innovations will speed up microsegmentation by automating, creating, and enforcing segmentation policies. ",
        listText:
          "There's a growing need for training machine learning models to automatically identify group assets on the network and then implement segmentation policies based on the risk associated with each group. These automated policies will help enterprises quickly respond to threats and protect sensitive assets without requiring manual intervention. Look for the industry to move forward on this dimension of AI and ML R&D in zero trust and microsegmentation in 2023.",
      },
      {
        listHeading:
          "Stepwise reductions in incident response times based on advances in microsegmentation technology are coming this year. ",
        listText:
          "In 2023 microsegmentation can help improve the speed and accuracy of identifying a threat and respond to it exponentially faster than was possible just two years ago. Organizations can more quickly identify potential incidents and respond by providing a more detailed view of network traffic. Microsegmentation will make performance and accuracy gains by providing a more granular view of enterprise networks, enabling CISOs, CIOs to create policies fine-tuned to specific roles, and users, ensuring that only authorized personnel have access to sensitive data.",
      },
      {
        listHeading: "Mobile devices get microsegmentation religion. ",
        listText:
          "With the proliferation of mobile devices, enterprises will need to ensure that the security of these devices is up to par with the security of their main networks. Zero trust and microsegmentation are securing their networks today, and in 2023, the individual device will be protected through microsegmentation using AirGap's Zero Trust Everywhere solution to ensure that these devices are secure, as they can be configured only to allow authorized users to access them.",
      },
      {
        listHeading:
          "CISOs double down on network analytics and machine learning tools for greater network visibility as part of their microsegmentation plans. ",
        listText:
          "These tools will enable automated network activity monitoring, allowing faster and more accurate detection of malicious activities. In addition, micro-segmentation will be used to create granular policies that will further enable the detection and prevention of malicious activities across multiple networks in an enterprise. As a result, enterprises will be able to identify and respond to security threats promptly and accurately.",
      },
      {
        listHeading:
          "Microsegmentation will improve automation by providing more granular control over network security policies. ",
        listText:
          ". Automating microsegmentation will enable enterprises to define and enforce security policies tailored to their specific needs. This will reduce the risk of human error and allow security teams to quickly adjust their policies in response to changing threat landscapes. Finally, advances in automation will enable enterprises to continuously monitor and enforce microsegmentation policies, ensuring that networks remain secure at all times.",
      },
      {
        listHeading:
          "Strengthening their compliance posture will drive more enterprises to adopt microsegmentation in 2023. ",
        listText:
          "Microsegmentation's innate strengths in defining and enforcing granular security policies are essential to enterprises strengthening their compliance posture. Monitoring network activity more closely and identifying potential security gaps is the goal. Microsegmentation will also see increased demand, given its ability to provide a detailed audit trail relative to security policies. That's proving essential for meeting and maintaining regulatory requirements. As a result, organizations can ensure their networks remain compliant and secure in the face of increasing cyber threats.",
      },
      {
        listHeading:
          "Expect to see the quality of training on zero-trust apps and platforms increase over the coming year, redefining how cloud-based systems are sold and deployed. ",
        listText:
          "As the quality of training on zero-trust applications and platforms improves, adoption rates will climb, and enterprises will gain new insights into the threatscape they're confronting today. Microsegmentation will benefit the most from the transition to more intuitive training by reducing threat surfaces and protecting endpoints and identities with least privileged access.",
      },
    ],
    subheading: "Conclusion",
    subText:
      "In conclusion, simplifying cybersecurity to gain more speed is the catalyst that will drive zero trust and microsegmentation adoption in 2023. CIOs and CISOs are pursuing a consolidation strategy to gain more speed and value from real-time telemetry. The key focus for many is to speed up progress on microsegmentation as core to their Zero Trust Network Access (ZTNA) strategic goals.According to the PwC's 2023 Global Digital Trust Insights Report, 75% of security leaders say there is too much complexity in their cybersecurity systems and stacks. To address this, organizations are adopting a more streamlined approach to security and quickening the implementation of zero trust and microsegmentation adoption. Utilizing microsegmentation to shrink threat surfaces, protect endpoints, increase mobile security, and gain more insight into telemetry data are just a few areas of innovation that will help accelerate zero trust in 2023.",
  },
]

export const manufactureData = [
  {
    heading:
      "Why Manufacturers Need To Get Stronger at Zero Trust Starting with Microsegmentation",
    text:
      "With more unprotected identities and endpoints than any other industry, manufacturing's many attack surfaces are a magnet for cyberattacks. It's not the breach that shuts plants down; it's attackers' lateral movements across networks where they install ransomware and malicious software payloads they'll launch in the future.The most recent IBM Security X-Force Threat Intelligence Index found that manufacturing is the most attacked industry worldwide, accounting for 23% of all ransomware attacks last year. 61% of breach attempts on manufacturers targeted operational technology (OT) systems essential to manufacturing operations first. A core part of many manufacturers’ OT tech stacks is Industrial Control Systems (ICS). It is often the most vulnerable to an attack because they're designed for process monitoring, reporting, and speed first, with little thought given to security.A typical ICS is among a manufacturer's most porous and unprotected IT assets. Last year Cybersecurity and Infrastructure Security Agency (CISA) warned that advanced persistent threat (APT) criminal gangs are targeting many of the most popular industrial control system (ICS) and SCADA devices. Manufacturers' vulnerabilities are becoming better known through the rapid growth of new endpoint technologies, including IoMT and remote sensing devices deployed to deliver real-time data.",
    img: webinarImage,
  },
  {
    heading: "Choose Zero Trust First, And Speed Will Follow",
    text:
      "The competitive intensity in manufacturing today prioritizes speed and delivering customer orders on time or early. Resolving to become stronger at zero trust gives manufacturers the one competitive advantage they can't find anywhere else: bulletproof operations and resiliency at a time when their industry is a favorite target.The manufacturers I've spoken with tell me that closing the gaps between IT and OT systems provides unexpected efficiency and speed gains. Streamlining how employees sign on and use systems that provide least privileged access without requiring lengthy authentication workflows is increasing productivity. Having suppliers and virtual employees as part of a zero trust-based infrastructure saves time and improves collaboration.“Getting the basics of zero trust right helped us remove the roadblocks of communicating in real-time with suppliers, production partners, and our virtual employees, resulting in efficiency gains measured in hours saved and greater collaboration,” the Chief Operating Officer of a leading technology products manufacturer told me recently. He continued saying “zero trust is table stakes for our distributed operations, it’s core to how we operate and proved to me cybersecurity is a business decision.” He continued by saying that any manufacturing business, including his, would find it tough to recover from a weeks-long disruption due to a ransomware attack.The efficiency and speed gains manufacturers are looking for are being found in zero trust. Gaining process improvements by closing the IT and OT system gaps is happening, as collaboration and real-time communication with suppliers and production partners keep schedules on track. Best of all, there’s no disruption to production lines because microsegmentation stops any intrusion immediately at the endpoint or threat surface before attackers can breach the network.",
  },
  {
    heading: "What Manufacturers Can Do Now To  Get Stronger With Zero Trust",
    text:
      "Reducing their threat surfaces with zero trust, starting with microsegmentation, helps increase efficiency, provides speed gains, and averts potentially devastating cyberattacks. Many manufacturers I speak to about zero trust see it as a business decision first, one that controls the risk of their production lines being disrupted.Here are the most common ways manufacturers are getting started with zero trust. One key takeaway from my conversations with them is that zero-trust security frameworks don’t need to be complex or expensive to be effective. NIST also provides a series of cybersecurity resources for manufacturers.",
  },
]

export const protectionData = [
  {
    heading:
      "Start with microsegmentation to shrink your company’s attack surface. ",
    subText:
      "CIOs and security teams say that having the flexibility to define microsegmentation down to the device, identity, and IoMT sensor level is an ideal fit for how they’ve designed their manufacturing IT and OT networks. What makes microsegmentation challenging for manufacturers is how often their endpoints change, including IoMT sensors used throughout the manufacturing process.My team and I designed AirGap’s Zero Trust Everywhere solution to adapt quickly across manufacturers' constantly changing endpoints, which are the most fluid attack surfaces they’re protecting today. We invented an agentless segmentation technology that would alleviate the need to install and keep endpoint agents patched and updated. That’s a significant cost and time saver for our manufacturing customers because we handle that with the AirGap Gateway. The following graphic explains how AirGap network protection is designed to reduce threat surfaces and eliminate an attacker's potential for lateral movement.",
  },
  {
    img: protectionImage,
  },
  {
    heading:
      "Make it a high priority to protect identities with MFA, SSO, or passwordless authentication. ",
    subText:
      "Core to zero trust is authenticating every device, session, and resource request for each identity on a network, and that starts by treating every human and machine identity as the security perimeter of your network. 74% of breaches start with privileged access abuse and quickly escalate into attacks on Active Directory (AD) and other core systems that control privileged access credentials. CIOs consider MFA a quick win as part of their zero trust strategy because it’s a part of the framework that lends itself well to measuring progress. ''We know nearly all account compromise attacks can be stopped outright, just by using MFA. It's a proven, effective way to thwart bad actors,'' said Karen S. Evans, managing director of Cyber Readiness Institute.",
  },
  {
    heading:
      "Take on the challenge of securing endpoints, starting with those in the IT and OT systems gap. ",
    subText:
      "ICS-based endpoints are the most challenging to protect but also the most at risk of an intrusion attempt. Many sensors and monitoring systems are part of a typical ICS, making protecting an OT tech stack more challenging. AirGap’s proven ability to secure endpoints at the IP endpoint alleviates the need to connect to every sensor, reducing the blast radius if any intrusion attempts to the sensor. Manufacturing runs on endpoints as conduits to e-commerce, supplier, and customer transactions. Getting security right on endpoints is core to a successful zero-trust strategy.",
  },
  {
    heading: "The Future of Manufacturing Security Is Zero Trust",
    subText:
      "The bottom line is that zero trust is the efficiency and speed multiplier manufacturers are looking for and need to compete in the year ahead. With manufacturing considered a soft target by attackers and the world industry leader in ransomware attacks, every manufacturer needs to get started on their zero trust security framework and strategy. This article aims to provide the three most common and successful areas to start. Manufacturing’s future will be defined by how successfully it adopts zero trust and secures the proliferating number of endpoints created to serve customers and grow their businesses.",
  },
]

export const ceoBlogData = [
  {
    text:
      "Targeting gaps between Operational technology (OT), IoMT, and Industrial Control Systems (ICS) is a favorite strategy of cybercriminal gangs looking for large ransomware payouts. Processing plants, utilities, and core infrastructure are prioritized as soft targets by advanced persistent threat (APT) criminal gangs and nation-state hackers who actively target the most popular ICS and Supervisory Control and Data Acquisition (SCADA) devices. The Cybersecurity and Infrastructure Security Agency (CISA) found that APT and cybercriminal gangs increased their real-time monitoring and surveillance of SCADA networked devices and sensors to record levels in 2022. APT and cybercriminal gangs have used advanced AI and Ml-based methods to identify unprotected sensors, endpoints, and devices to launch attacks at record levels, according to IBM's 2022 X-Force Threat Intelligence Report. In the first nine months of their study, they found an astounding 2,204% increase in automated surveillance activity by APT criminal gangs and nation-state hackers.",
  },
  {
    img: webinarImage,
  },
  {
    img: ceoImage,
  },
  {
    text:
      "APT and cybercriminal gangs' favorite surveillance and attack targets are manufacturers and industrial solutions whose ICS and SCADA systems have no microsegmentation to kill the lateral movement. The result: industries that rely most on ICS and SCADA are attackers' favorite ransomware targets. Source: Dragos Industrial Ransomware Analysis: Q3 2022",
  },
]

export const digitaLPandemic = [
  {
    heading:
      "Why Ransomware Is The Digital Pandemic OT And IoMT Aren't Prepared For",
    text:
      "Attacks on processing plants, core infrastructure, supply chains, and manufacturing networks that rely on ICS and SCADA systems are growing into a digital pandemic. 36% of all ransomware attacks that occurred worldwide in Q3 2022 targeted industrial organizations and infrastructures in North America first, jumping from 26% just three months before. APT and cybercriminal gangs see ICS and SCADA systems as ''the keys to the kingdom'' because each provides immediate unprotected access to manufacturers' core systems, machinery, and production assets across processing plants. Microsegmentation is helping to stop the ransomware pandemic by eliminating lateral movement from any ransomware-infected endpoint, sensor, or device to the company network and servers. AirGap’s Zero Trust Everywhere solution is configurable to define micro-segments that support and streamline how a given business operates. Hardening endpoints and shrinking attack surfaces using microsegmentation require granular context-based policy enforcement. Being able to ring-fence infected devices by combining microsegmentation and policy enforcement kills any chance of lateral movement by malware or ransomware on a network. The value of micro-segmenting every sensor as an endpoint is evident based on Gartner's IoT Reference Architecture shown below, which is just as applicable to any IoMT network. When ransomware successfully penetrates edge devices and next penetrates platform systems to infect many servers quickly, enterprises have a full-scale breach in progress. Micro-segmentation consolidates edge-based endpoints, shrinking the total attack surface while immediately stopping the lateral movement of the attack payload.",
  },
  {
    img: digitalImage,
    text:
      "Gartner's IoT Reference Architecture provides a valuable framework for IoMT Networks. Source: Is the Purdue Model Relevant in a World of Industrial Internet of Things (IIoT) and Cloud Services? Mission Secure blog",
  },
  {
    heading: "How OT and IoMT Networks Benefit From Microsegmentation",
    text:
      "The following are the benefits that need to be included in a business case for microsegmentation:",
    dropList: [
      {
        heading:
          "Time and cost savings from improved asset discovery and identification to the sensor level across ICS and IoMT networks using micro-segmentations’ granular policy management. ",
        text:
          "It’s common knowledge that up to 40% of sensor-based endpoints on ICS, SCADA, and IoMT networks aren’t discoverable on networks today. Not knowing if sensors are active and whether they’re secured often leads to inventory-based patch management. Assuming two technicians are assigned to complete a sensor audit every six months, and it takes three weeks to get done across all centralized and remote locations each time, it will take 1,250 hours in one year. At a fully burdened rate of $125 per hour, tracking down and securing sensors is approximately $156,250. Micro-segmentation would alleviate the need for periodic audits to protect sensors and endpoints.",
      },
      {
        heading:
          "Not having to troubleshoot software agent and sensor updates on endpoints reduce Plant Maintenance and Production Engineering costs. ",
        text:
          "The Chief Operating Officer (COO) of a plastics process manufacturing plant says that microsegmentation helps reduce the time spent up[dating endpoint agents so often by identifying every endpoint as a specific micro-segment. Plant Maintenance and Production Engineering teams waste over 670 hours yearly at a fully burdened cost per hour of $125, saving $83,750 annually.",
      },
      {
        heading:
          "Eliminating the risk of a USB-based breach infiltrating the ICS and IoMT systems and spreading across corporate networks. ",
        text:
          "The average cost of a single breach is $360,000, according to Ponemon’s latest study. The granular controls microsegmentation provides, along with restricting lateral access, are averting breaches today.",
      },
      {
        heading:
          "Eliminating overlapping sensor and network zones, saving on hardware, software, and services licensing and maintenance costs. ",
        text:
          "The data captured by micro-segmenting work areas and network zones across processing plants often uncovered duplication of networks and hardware. One COO found that interdomain controllers and security systems had expensive licensing costs at $15,400 each in ten different zones across all processing plants. Microsegmentation helped find savings of $154,000 by freeing the manufacturer from relying on interdomain control and expensive server-based licensing needed to operate them.",
      },
      {
        heading:
          "Reducing the risk of fines and regulatory action by enforcing security controls consistently. Microsegmentation helps reduce compliance costs by making it easier to implement and enforce security controls required by regulatory and industry compliance standards. ",
        text:
          "For example, the Health Insurance Portability and Accountability Act (HIPAA) requires healthcare organizations to maintain consistent security standards across their networks to protect the confidentiality, integrity, and availability of protected health information (PHI). Tier 1 HIPAA fines start at $10,000 per violation, with an annual maximum of $50,000, and Tier 2 is $50,000 per violation, with an annual maximum of $1.5 million. Legal costs to contest a data security violation can average $25,000 in legal fees alone.",
      },
    ],
  },
  {
    heading: "Building A Business Case For Securing OT and IoMT Networks",
    text:
      "The following are the microsegmentation costs that need to be included in the business case:",
    dropList2: [
      {
        heading:
          "Annual, often multi-year microsegmentation licensing costs. Microsegmentation providers vary in their pricing models, costs, and fees. ",
        text:
          "Subscription fees of $50,000 a year are assumed for this analysis.",
      },
      {
        heading:
          "Change management, implementation, and integration costs increase with IT security, Operations, and IT Service Management (ITSM) integration complexity. ",
        text:
          "Expect an average price of between $40K to over $100K to integrate microsegmentation with the current security stack, including security information and event management (SIEM) systems.",
      },
    ],
    subText:
      "The best microsegmentation business cases provide a 360-degree view of costs, benefits, and why taking action now is needed. CISOs say they've doubled down on training, change management, and ongoing support costs to ensure successful implementation. Many include the following equation to provide an ROI estimate in their business cases. The Return on Investment (ROI) for the microsegmentation initiative is calculated as follows: ROI on Microsegmentation (MS) = (MS Initiative Benefits – MS Initiative Costs)/MS Initiative Costs x 100.",
  },
]

export const ceoTableData = [
  {
    heading: "Summary Of Microsegmentation Benefits",
    dropList: [
      {
        columnText:
          "Benefits of securing IT and IoMT Networks With Microsegmentation",
        columnDollar: "Savings Per Year",
      },
      {
        columnText:
          "Time and cost savings from improved asset discovery and identification to the sensor level across ICS and IoMT networks.",
        columnDollar: "$156,250",
      },
      {
        columnText:
          "Not having to troubleshoot software agent and sensor updates on endpoints reduce Plant Maintenance and Production Engineering costs.",
        columnDollar: "$83,750",
      },
      {
        columnText:
          "Eliminating the risk of a USB-based breach infiltrating the ICS and IoMT systems and spreading across corporate networks.",
        columnDollar: "$360,000",
      },
      {
        columnText:
          "Eliminating network zones is no longer needed, reducing hardware, software, and services licensing and maintenance costs.",
        columnDollar: "$154,000",
      },
      {
        columnText:
          "Reducing the risk of fines and regulatory action by enforcing security controls consistently.",
        columnDollar: "$25,000",
      },
      {
        columnText:
          "Value Of Microsegmentation Benefits To an OT and IoMT Network in a mid-size business",
        columnDollar: "$779,000",
      },
    ],
    text:
      "Based on CISOs' cost estimates of microsegmentation in a mid-size organization having the potential to save $779,000 a year and the assumption of AirGap's Zero Trust Everywhere solution costing $150,000 a year, investing in microsegmentation will yield a return of $4.19 for every dollar invested. Bottom Line:  ICS and SCADA systems are among the most porous and poorly protected networks in manufacturing, utilities, and infrastructure, making the business case for protecting them with microsegmentation. All it takes is one breached sensor or threat surface to lose millions of dollars in revenue and productivity.",
  },
]

export const coreEndpoint = [
  {
    heading: "Why Microsegmentation Is Core To Endpoint Security in 2023",
    para:
      "Cyberattackers consider endpoints to be soft targets, easily defeated, and essential to taking control of a company's identities and access privileges. Endpoints are every business's flex points and transaction hubs, making them the most lucrative and favored target. Gartner found that 75% of security failures are attributable to human error in managing access privileges and identities, up from 50% two years ago.  Ponemon Institute and Adaptiva's 2022 report, Managing Risks & Costs At The Edge, found that 54% of organizations have had an average of five attacks on their endpoints in the past year. The annual cost of these annual attacks is $1.8 million or $360,000 per attack. These findings show that endpoint security needs to be more cyber-resilient. Microsegmentation is helping to make that happen in the context of organizations' zero-trust security frameworks and strategies. The first step to shutting down endpoint attacks is to strengthen cyber resilience. CISOs and CIOs need to resolve to become stronger at zero trust in 2023. Blocking any breach from progressing by limiting the cyberattacker's lateral movement across networks is a first step. Enforcing more granular per-session-based access controls simultaneously further limits breach attempts and makes them fail. Supporting multiple methods of providing Single Sign-On (SSO) and Multi-Factor Authentication (MFA) on an integrated, cloud-based Zero Trust Isolation Platform that's adaptive enough to define microsegmentation down to the device and IP address level is also critical. We've designed the platform and every component of AirGap's Zero Trust Everywhere solution to ensure microsegmentation contributes to our customers' zero trust security framework and initiatives. It's great hearing from our customers and learning how effective the Airgap Zero Trust Isolation Platform is at shrinking attack surfaces and limiting the blast radius of breaches while containing breaches so they don't progress past endpoints.",
  },
  {
    heading: "Get Zero Trust Strong At Endpoints First",
    para:
      "Breaches are inevitable. Taking steps to be cyber-resilient with microsegmentation is core to endpoint security and where many businesses need to start. Ensuring that endpoint security is Zero Trust Strong can't be left to chance. No amount of endpoint software agents installed can stop all breaches. Cyberattackers look for over-configured endpoints with software conflicts because they are easier to hack than less-configured ones. Instead of over-configuring endpoints with yet another software agent, it is time for CISOs and CIOs to accept that breaches are inevitable and prepare to repel and shut down the ever-growing variety of cyberattacks with a plan that puts zero trust first. Zero trust is about absorbing the worst of what cyber attackers can launch against any business and emerging more resilient from the attacks. Cyber-resiliency, not cyber-avoidance, is the goal. Getting Zero Trust Strong is the cybersecurity fitness test every business needs to keep challenging themselves to complete to keep improving their cyber-resilience.",
  },
  {
    heading: "We Deliver Cyber-Resilience",
    para:
      "At Airgap Networks, we're driven to make our customers more cyber-resilient and Zero Trust Strong without requiring them to install endpoints, modify applications or change how they do business. Our mission is to help them simplify and secure their corporate infrastructures while also enabling their virtual workforces to thrive in all the locations they are working from. Airgap's Zero Trust Everywhere solution is a security approach that treats every identity's endpoint as a separate microsegment. This approach provides granular context-based policy enforcement for every attack surface, which eliminates the chance of lateral movement through the network. Additionally, AirGap's Trust Anywhere architecture includes an Autonomous Policy Network that scales microsegmentation policies network-wide immediately.",
  },
  {
    img: protectionImage,
    para:
      "CAPTION AirGap's approach to microsegmentation is innovative in that it does not require modifications to existing technology stacks, new endpoint software agents, or new applications to prevent breaches from progressing onto networks and infrastructure.",
  },
]

export const endpointList = [
  {
    para:
      "Airgap Networks is concentrating on how we can deliver measurable, lasting benefits to our customers by continually improving our Zero Trust Isolation Platform to deliver greater cyber-resilience. The following are just a few of the many benefits they are achieving today:",
    dropList: [
      {
        listHeading:
          "Eliminating the wasted time of continually monitoring and patching endpoint agents. ",
        listText:
          "CISOs and CISOs tell me their teams are already stretched thin, and one of the most valuable benefits Airgap Networks brings them is more time. Using Airgap's agentless segmentation, IT and cybersecurity teams don't have to waste time doing patch management and can concentrate on larger, more complex challenges.",
      },
      {
        listHeading: "More consistent, dynamic policy enforcement. ",
        listText:
          "Airgap Networks is designed to deliver consistent policy enforcement that can flex and adapt as an organization's security and business needs change. Airgap's agentless segmentation acts as the first hop in the packet to enforce consistent and dynamic policy enforcement.",
      },
      {
        listHeading:
          "Granular policy controls contribute to greater visibility and scale. ",
        listText:
          "We've designed the Airgap Networks policy controls with the needs of security teams who manage microsegmentation in mind. Our granular policy controls contribute to greater visibility across distributed networks, scaling across automated machine endpoints, including virtual machines.",
      },
    ],
    subheading: "Conclusion",
    subText:
      "Microsegmentation has proved to be an invaluable tool for protecting endpoints and data. Airgap's product strategy and platform focus on providing granular security management, limiting attack surfaces, and automating access and policy enforcement. Our goal is to provide a scalable, secure microsegmentation platform that perfectly fits an organization's broader zero-trust security frameworks and initiatives. The Airgap approach to microsegmentation also delivers measurable, reliable results across a broad spectrum of industries, including critical infrastructure, healthcare, manufacturing, and transportation.",
  },
]

// Microsegmentation Fedramp page
export const fedRam = [
  {
    heading: "Introduction",
    fedRamDroplist: [
      {
        listText:
          "FedRAMP is a US government program that provides a standardized approach to security assessment, authorization, and continuous monitoring for cloud-based products and services used by federal agencies. It requires cloud service providers (CSPs) to implement security controls that align with the NIST Cybersecurity Framework and undergo an independent assessment by a third-party assessor. FedRAMP helps to ensure the security of cloud services used by federal agencies, reduce risk for federal agencies, and streamline the security assessment and authorization process for federal agencies.",
      },
    ],
  },
  {
    heading: "FedRAMP Certification",
    fedRamDroplist: [
      {
        listText:
          "FedRAMP requires CSPs to implement security controls that align with the National Institute of Standards and Technology (NIST) Cybersecurity Framework and undergo an independent assessment by a third-party assessor (3PAO) to validate that these security controls are in place and operating effectively. The assessment results are then reviewed by a FedRAMP-accredited third-party authorization body (3PAB), which makes a recommendation to the Joint Authorization Board (JAB) regarding the authorization of the cloud service.",
      },
      {
        listText:
          "By requiring CSPs to undergo a comprehensive security assessment and authorization process, FedRAMP helps to ensure that cloud services used by federal agencies meet strict security standards, reducing risk and protecting sensitive information. Additionally, the FedRAMP authorization process helps to streamline the security assessment and authorization process for federal agencies, reducing the time and effort required to evaluate and use cloud services.",
      },
      {
        listText:
          "Overall, FedRAMP is an important program that helps to ensure the security of cloud services used by federal agencies and to reduce risk for federal agencies when using cloud services. Obtaining FedRAMP certification is a rigorous process, but it demonstrates a commitment to security and provides a competitive advantage for cloud service providers.",
      },
    ],
  },
  {
    heading:
      "How does Airgap Networks’ microsegmentation fit into this framework?",
    fedRamDroplist: [
      {
        listText:
          "Network segmentation is a key tool for organizations to achieve and maintain compliance with the Federal Risk and Authorization Management Program (FedRAMP). By dividing a network into smaller, isolated segments, network segmentation helps organizations to reduce risk and enhance the overall security of their network.",
      },
      {
        listText:
          "In the context of FedRAMP, network segmentation can be used to separate sensitive information, such as federal data, from other types of data. This helps to limit the scope of a security breach, reduce the attack surface, and improve the overall security of the network. Additionally, network segmentation helps organizations to enforce access controls, ensuring that only authorized individuals have access to sensitive information.",
      },
      {
        listText:
          "By implementing network segmentation, organizations can demonstrate that they have taken steps to protect sensitive information and to comply with FedRAMP security standards. Network segmentation can also help organizations meet other FedRAMP requirements, such as regular security risk analyses, encryption, and incident response planning.",
      },
      {
        listText:
          "Overall, network segmentation is a critical aspect of FedRAMP compliance and can provide an extra layer of security that helps organizations reduce risk, protect sensitive information, and improve their overall security posture. By implementing network segmentation, organizations can demonstrate their commitment to security and enhance their chances of achieving and maintaining FedRAMP certification.",
      },
      {
        listText:
          "Airgap Networks’ agentless microsegmentation places each endpoint into its own isolated network segment and allows only authorized communication between them. The default security policy is to disallow any communication between each endpoint/network micro segment unless authorized by the security operator. In this way, servers which are processing sensitive federal data can be placed in their own isolated network segments and only authorized communication permitted between them.",
      },
    ],
  },
  {
    heading: "Summary",
    fedRamDroplist: [
      {
        listText:
          "Network microsegmentation helps organizations comply with FedRAMP by limiting the scope of a security breach, reducing the attack surface, and improving the overall security of the network. It also helps enforce access controls, ensure that only authorized individuals have access to sensitive information, and demonstrate the organization's commitment to security, which is a key aspect of FedRAMP compliance.",
      },
      {
        listText:
          "Microsegmentation is an integral part of Airgap’s Zero Trust Everywhere solution, contributing to our customers' zero trust security initiatives and frameworks.",
      },
    ],
  },
]

// Microsegmentation Fisma page
export const fisma = [
  {
    heading: "Introduction",
    fismaDroplist: [
      {
        listText:
          "The Federal Information Security Modernization Act (FISMA) is a United States federal law enacted in 2002 that requires federal agencies to implement and maintain information security programs to protect their information and information systems. The law defines information security as ''the protection of information and information systems from unauthorized access, use, disclosure, disruption, modification, or destruction in order to provide integrity, confidentiality, and availability.''",
      },
      {
        listText:
          "FISMA requires federal agencies to comply with minimum security standards set by the National Institute of Standards and Technology (NIST) and to periodically assess the effectiveness of their information security programs. FISMA also requires federal agencies to report annually on their information security posture, including any breaches or incidents of unauthorized access, use, disclosure, disruption, modification, or destruction of information.",
      },
      {
        listText:
          "The NIST Cybersecurity Framework (CSF) is used by federal agencies to comply with FISMA requirements and to implement and maintain information security programs. The framework provides a structured approach to managing and reducing cybersecurity risk by guiding organizations through a series of activities, outcomes, and references for each of its five functions: Identify, Protect, Detect, Respond, and Recover. By following the NIST CSF, federal agencies can effectively implement and maintain information security programs that comply with FISMA requirements and reduce their risk of a cybersecurity event.",
      },
    ],
  },
  {
    heading: "Federal Information Security Modernization Act (FISMA)",
    fismaDroplist: [
      {
        listText:
          "The Federal Information Security Modernization Act (FISMA) is a U.S. federal law enacted in 2002 that mandates that federal agencies implement and maintain information security programs to protect their information and information systems. FISMA establishes a framework for managing and protecting the security of federal information and information systems by requiring agencies to comply with minimum security standards set by the National Institute of Standards and Technology (NIST).",
      },
      {
        listText:
          "FISMA requires federal agencies to perform periodic risk assessments to determine the potential impact of a security breach on their information and information systems. Based on these assessments, agencies must implement security controls and measures to mitigate identified risks. FISMA also requires agencies to report annually on their information security posture, including any incidents of unauthorized access, use, disclosure, disruption, modification, or destruction of information.",
      },
      {
        listText:
          "FISMA requires that federal agencies implement a comprehensive security program that includes, but is not limited to, the following elements: ",
      },
    ],
    fismaDroplist2: [
      {
        listHeading: "Access control: ",
        listText:
          "Controlling access to information and information systems by identifying, authenticating, and authorizing users and devices.",
      },
      {
        listHeading: "Maintenance: ",
        listText:
          "Regularly updating and patching systems and applications to prevent vulnerabilities from being exploited.",
      },
      {
        listHeading: "Data protection: ",
        listText:
          "Protecting sensitive information by encrypting data in transit and at rest, and by implementing data backup and recovery strategies.",
      },
      {
        listHeading: "Awareness and training: ",
        listText:
          "Educating and training employees on cybersecurity policies and procedures to help prevent human error from contributing to a cybersecurity event.",
      },
      {
        listHeading: "Protective technology: ",
        listText:
          "Implementing technical controls such as firewalls, intrusion detection systems, and security information and event management (SIEM) systems to detect and respond to potential security threats.",
      },
    ],
    text:
      "In summary, FISMA requires federal agencies to implement and maintain information security programs that protect their information and information systems from unauthorized access, use, disclosure, disruption, modification, or destruction. FISMA is designed to help ensure the confidentiality, integrity, and availability of federal information and information systems, and to reduce the risk of a cybersecurity event.",
  },
  {
    heading:
      "How does Airgap Networks’ microsegmentation fit into this framework?",
    fismaDroplist: [
      {
        listText:
          "Network microsegmentation can help organizations comply with the Federal Information Security Modernization Act (FISMA) by reducing the risk of a cybersecurity event and limiting the exposure of critical assets and sensitive information. By dividing a network into smaller, separate segments, organizations can reduce the attack surface and limit the spread of a potential security breach, while also enabling the implementation of different security policies for different segments of the network.",
      },
      {
        listText:
          "By using network microsegmentation, organizations can better protect their sensitive information and information systems, and meet the requirements set by FISMA for access control, data protection, and protective technology. Network micro-segmentation enables organizations to define and enforce granular security policies based on the security posture of individual devices and systems, and to detect and respond to potential security threats more effectively.",
      },
      {
        listText:
          "Additionally, network microsegmentation can help organizations meet the FISMA requirement for periodic risk assessments by enabling them to continuously monitor and assess the security posture of individual segments of their network. This can help organizations identify potential security risks and vulnerabilities, as well as make informed decisions about the implementation of security controls and measures to mitigate these risks.",
      },
      {
        listText:
          "In conclusion, network microsegmentation is an important aspect of the information security program required by FISMA, and can help organizations effectively manage and reduce their cybersecurity risk. By implementing network micro-segmentation, organizations can ensure the confidentiality, integrity, and availability of their information and information systems, and meet the requirements set by FISMA for information security.",
      },
      {
        listText:
          "Airgap Networks’ agentless microsegmentation places each endpoint into its own isolated network segment and allows only authorized communication between them. The default security policy is to disallow any communication between each endpoint/network micro segment unless authorized by the security operator. In this way, servers which are processing sensitive payment card information can be placed in their own isolated network segments and only authorized communication permitted between them.",
      },
    ],
  },
  {
    heading: "Summary",
    fismaDroplist: [
      {
        listText:
          "Network microsegmentation helps organizations comply with FISMA by reducing the risk of a cybersecurity event and limiting the exposure of critical assets and sensitive information. By dividing a network into smaller, separate segments and enforcing granular security policies, organizations can detect and respond to potential security threats more effectively, and meet the FISMA requirements for access control, data protection, and protective technology. Micro-segmentation enables organizations to continuously monitor and assess their network security posture and make informed decisions about security controls, thereby helping them meet the FISMA requirement for periodic risk assessments.",
      },
      {
        listText:
          "Microsegmentation is an integral part of Airgap’s Zero Trust Everywhere solution, contributing to our customers' zero trust security initiatives and frameworks.",
      },
    ],
  },
]

// Microsegmentation Gdpr page
export const gdpr = [
  {
    heading: "Introduction",
    gdprDroplist: [
      {
        listText:
          "The General Data Protection Regulation (GDPR) is a regulation of the European Union (EU) that harmonizes data protection laws across all EU member states. It gives individuals greater control over their personal data and requires organizations to be transparent about how they use personal data, and to take appropriate measures to ensure its security. The GDPR applies to all organizations, regardless of location, that process personal data of individuals located in the EU.",
      },
    ],
  },
  {
    heading: "General Data Protection Regulation",
    gdprDroplist: [
      {
        listText:
          "The General Data Protection Regulation (GDPR) is a regulation of the European Union (EU) that was introduced in May 2018. It replaces the 1995 EU Data Protection Directive and harmonizes data protection laws across all EU member states.",
      },
      {
        listText:
          "The GDPR sets out strict rules for how organizations must collect, process, store, and handle personal data of individuals located in the EU. It applies to all organizations, regardless of where they are located, that process personal data of individuals located in the EU.",
      },
      {
        listText:
          "The GDPR gives individuals greater control over their personal data and requires organizations to be transparent about how they use personal data. Organizations must also take appropriate technical and organizational measures to ensure the security of personal data and must report certain types of data breaches to the relevant authorities and, in some cases, to the individuals affected.",
      },
      {
        listText:
          "Overall, the GDPR is an important piece of legislation that provides enhanced protections for the personal data of individuals in the EU and sets out clear and comprehensive rules for organizations to follow. The GDPR has far- reaching implications for organizations that process personal data, and it is essential for organizations to understand and comply with the regulations.",
      },
    ],
  },
  {
    heading:
      "How does Airgap Networks’ microsegmentation fit into this framework?",
    gdprDroplist: [
      {
        listText:
          "Network segmentation can help organizations comply with the General Data Protection Regulation (GDPR) by reducing the risk of unauthorized access to personal data. By dividing a network into smaller, isolated segments, network segmentation helps to limit the scope of a security breach, reducing the attack surface and improving the overall security of the network.",
      },
      {
        listText:
          "Organizations can use network segmentation to separate personal data from other types of data, ensuring that sensitive information is only accessible to authorized individuals. This helps to enforce access controls, reduce the risk of unauthorized access to personal data, and improve the overall security of the network.",
      },
      {
        listText:
          "Network segmentation also helps organizations to monitor and track access to personal data, which is an important requirement under the GDPR. Organizations must be able to demonstrate that they have taken appropriate measures to protect personal data and that they have the necessary technical and organizational controls in place.",
      },
      {
        listText:
          "Overall, network segmentation is a critical aspect of GDPR compliance and can provide an extra layer of security that helps organizations reduce risk, protect personal data, and improve their overall security posture. By implementing network segmentation, organizations can demonstrate their commitment to data protection and enhance their chances of achieving and maintaining GDPR compliance.",
      },
      {
        listText:
          "Airgap Networks’ agentless microsegmentation places each endpoint into its own isolated network segment and allows only authorized communication between them. The default security policy is to disallow any communication between each endpoint/network micro segment unless authorized by the security operator. In this way, servers which are processing sensitive personal data can be placed in their own isolated network segments and only authorized communication permitted between them.",
      },
    ],
  },
  {
    heading: "Summary",
    gdprDroplist: [
      {
        listText:
          "Network segmentation helps organizations comply with GDPR by reducing the risk of unauthorized access to personal data, enforcing access controls, and improving overall network security. It allows organizations to separate personal data from other types of data, monitor and track access to personal data, and demonstrate that appropriate measures have been taken to protect it. By implementing network segmentation, organizations can enhance their security posture, reduce risk, and demonstrate their commitment to data protection, which is a critical aspect of GDPR compliance.",
      },
      {
        listText:
          "Microsegmentation is an integral part of Airgap’s Zero Trust Everywhere solution, contributing to our customers' zero trust security initiatives and frameworks.",
      },
    ],
  },
]

// Microsegmentation Hipaa page
export const hipaa = [
  {
    heading: "Introduction",
    hipaaDroplist: [
      {
        listText:
          "In this article, we will look specifically at the Health Insurance Portability and Accountability Act (HIPAA) standard, and how Airgap micro segmentation can help achieve organizations achieve compliance with this standard.",
      },
      {
        listText:
          "The Health Insurance Portability and Accountability Act (HIPAA) is a US federal law that sets standards for protecting the privacy and security of individuals' health information. It applies to healthcare providers, health plans, health insurance companies, and other entities that handle protected health information (PHI). HIPAA requires organizations to implement administrative, physical, and technical safeguards to ensure the confidentiality, integrity, and availability of PHI, and to protect against unauthorized access, use, disclosure, and destruction of PHI. HIPAA also establishes standards for individuals' rights to access and control their health information and imposes penalties for non-compliance. Overall, HIPAA is an important tool for promoting privacy and security in the handling of health information and helps to ensure that sensitive medical information is protected.",
      },
    ],
  },
  {
    heading: "The HIPAA Set of Standards",
    hipaaDroplist: [
      {
        listText:
          "The Health Insurance Portability and Accountability Act (HIPAA) was enacted in 1996 to protect the privacy and security of individuals' health information and to ensure the portability of health insurance coverage. It establishes standards for the handling of protected health information (PHI) and applies to covered entities, which include healthcare providers, health plans, health insurance companies, and other entities that handle PHI.",
      },
      {
        listText:
          "HIPAA requires covered entities to implement administrative, physical, and technical safeguards to protect the confidentiality, integrity, and availability of PHI. This includes implementing access controls to ensure that only authorized individuals have access to PHI, conducting regular security risk analyses, encrypting and protecting PHI when it is stored or transmitted, and having incident response plans in place to respond to security incidents.",
      },
      {
        listText:
          "Additionally, HIPAA gives individuals certain rights with respect to their health information, such as the right to access their PHI, the right to request that their PHI be amended, and the right to receive an accounting of disclosures of their PHI. HIPAA also imposes penalties for non-compliance, including monetary fines and exclusion from participating in government healthcare programs.",
      },
      {
        listText:
          "Overall, HIPAA is an important piece of legislation that helps to promote privacy and security in the handling of health information. By setting standards for the protection of PHI and imposing penalties for non- compliance, HIPAA helps to ensure that sensitive medical information is protected and that individuals' rights to privacy and control over their health information are respected.",
      },
    ],
  },
  {
    heading:
      "How does Airgap Networks’ microsegmentation fit into this framework?",
    hipaaDroplist: [
      {
        listText:
          "Network segmentation is an important tool for organizations to comply with the Health Insurance Portability and Accountability Act (HIPAA) standards. By dividing a network into smaller, isolated segments, or ''zones,'' network segmentation helps to limit the scope of a security breach, reduce the attack surface, and improve the overall security of the network.",
      },
      {
        listText:
          "In the context of HIPAA, network segmentation can be used to separate sensitive health information, known as protected health information (PHI), from other types of data. This way, if a breach occurs, the attacker will not have access to the entire network and will not be able to access sensitive PHI. Network segmentation also helps to enforce access controls, ensuring that only authorized individuals have access to PHI.",
      },
      {
        listText:
          "In addition to improving security, network segmentation also helps organizations comply with other HIPAA requirements, such as regular security risk analyses, encryption of PHI, and incident response planning. By implementing network segmentation, organizations can demonstrate that they have taken steps to protect PHI and to comply with HIPAA standards.",
      },
      {
        listText:
          "Overall, network segmentation is a key aspect of HIPAA compliance and can provide an extra layer of security that helps organizations protect sensitive health information, comply with HIPAA standards, and improve their overall security posture.",
      },
      {
        listText:
          "Airgap Networks’ agentless network microsegmentation places each endpoint into its own isolated network segment and allows only authorized communication between them. The default security policy is to disallow any communication between each endpoint/network micro segment unless authorized by the security operator. In this way, servers which are processing sensitive payment card information can be placed in their own isolated network segments and only authorized communication permitted between them.",
      },
    ],
  },
  {
    heading: "Summary",
    hipaaDroplist: [
      {
        listText:
          "Airgap Networks’ agentless microsegmentation helps organizations comply with HIPAA standards by limiting the scope of a security breach, reducing the attack surface, and improving the overall security of the network. It also helps enforce access controls, ensure that only authorized individuals have access to PHI, and support regular security risk analyses, encryption, and incident response planning.",
      },
      {
        listText:
          "Microsegmentation is an integral part of Airgap’s Zero Trust Everywhere solution, contributing to our customers' zero trust security initiatives and frameworks.",
      },
    ],
  },
]

// Microsegmentation Iso 27001 page
export const iso27001 = [
  {
    heading: "Introduction",
    iso27001Droplist: [
      {
        listText:
          "ISO 27001 is an international standard for information security management systems (ISMS). It provides a systematic approach to manage sensitive information by applying a risk management process and gives requirements for establishing, implementing, maintaining, and continually improving information security. The standard specifies the use of security controls to protect confidentiality, integrity, and availability of information by applying a process of risk assessment and treatment. Organizations can use ISO 27001 as a framework to ensure that information assets are adequately protected and to demonstrate their commitment to cyber security.",
      },
    ],
  },
  {
    heading: "ISO 27001 Standard",
    iso27001Droplist: [
      {
        listText:
          "ISO 27001 is a globally recognized standard for information security management that provides a comprehensive framework for managing and protecting sensitive information. The standard outlines a systematic approach for managing information security risks, including the implementation of security controls to mitigate those risks.",
      },
      {
        listText:
          "The standard is based on a risk management process that involves identifying assets and the risks to those assets, evaluating the risks, treating the risks by implementing appropriate security controls, and continually monitoring and reviewing the effectiveness of those controls. This process is designed to help organizations of all sizes and types to protect their sensitive information and meet the increasing demands for data privacy and security.",
      },
      {
        listText:
          "ISO 27001 requires organizations to have a formal, documented information security management system (ISMS) in place. This ISMS must include policies, procedures, and processes to manage and protect information and should be regularly reviewed and updated to ensure that it remains effective in a constantly evolving threat landscape.",
      },
      {
        listText:
          "By implementing ISO 27001, organizations can demonstrate their commitment to cyber security and increase customer and stakeholder confidence in the security of their information. It can also help organizations to comply with various national and international regulations, including data privacy laws, and reduce the risk of security incidents and breaches.",
      },
    ],
  },
  {
    heading:
      "How does Airgap Networks’ microsegmentation fit into this framework?",
    iso27001Droplist: [
      {
        listText:
          "Network segmentation is a security technique that involves dividing a network into smaller segments or subnetworks to enhance the overall security of the network. In the context of ISO 27001, network segmentation can help organizations to achieve and maintain compliance by implementing various security controls and reducing the risk of security incidents and breaches.",
      },
      {
        listText:
          "By segmenting a network, organizations can isolate sensitive information and restrict access to it, reducing the attack surface and minimizing the potential impact of a security breach. This can also help to prevent unauthorized access and data exfiltration by implementing various access control measures, such as firewalls, virtual local area networks (VLANs), and network access control (NAC).",
      },
      {
        listText:
          "Network segmentation can also aid in the implementation of other security controls such as logging and monitoring, incident response, and data backup and recovery. By limiting access to sensitive information, organizations can better ensure that it is being protected and monitored and can more quickly respond to security incidents when they do occur.",
      },
      {
        listText:
          "In summary, network segmentation can play an important role in helping organizations to comply with ISO 27001 by providing additional security controls, reducing the risk of security incidents and breaches, and helping organizations to better protect and manage their sensitive information.",
      },
      {
        listText:
          "Airgap Networks’ agentless microsegmentation places each endpoint into its own isolated network segment and allows only authorized communication between them. The default security policy is to disallow any communication between each endpoint/network micro segment unless authorized by the security operator.",
      },
    ],
  },
  {
    heading: "Summary",
    iso27001Droplist: [
      {
        listText:
          "Network segmentation is a security technique that can help organizations achieve and maintain ISO 27001 compliance by dividing a network into smaller, isolated segments. This helps to reduce the attack surface, minimize the potential impact of security incidents, and enhance the implementation of security controls such as access control, logging and monitoring, incident response, and data backup and recovery. Network segmentation can also aid in protecting and managing sensitive information, which is a key requirement of ISO 27001.",
      },
      {
        listText:
          "Microsegmentation is an integral part of Airgap’s Zero Trust Everywhere solution, contributing to our customers' zero trust security initiatives and frameworks.",
      },
    ],
  },
]

// Microsegmentation Mitre page
export const mitre = [
  {
    heading: "",
    mitreDroplist: [
      {
        listText:
          "Network microsegmentation is a security practice that involves dividing a large network into smaller, isolated segments, or microsegments, to limit the potential damage of a security breach. The goal of microsegmentation is to improve security by reducing the attack surface, limiting the spread of malware or other malicious activities, and providing a more fine-grained level of control over network traffic.",
      },
      {
        listText:
          "Microsegmentation can be achieved through various technologies such as network virtualization, firewall rules, creating smaller isolated segments and access controls. By creating smaller, isolated network segments, organizations can restrict network traffic and access, and better control the flow of sensitive data within the network. This helps to minimize the risk of data breaches and other security incidents, and to ensure that sensitive data is protected even in the event of a security breach.",
      },
      {
        listText:
          "Airgap Networks’ agentless microsegmentation places each endpoint into its own isolated network segment and allows only authorized communication between them. Microsegmentation is an integral part of Airgap’s Zero Trust Everywhere solution, contributing to our customers' zero trust security initiatives and frameworks.",
      },
    ],
  },
  {
    heading: "MITRE ATT&CK Framework",
    mitreDroplist: [
      {
        listText:
          "The MITRE ATT&CK framework is a comprehensive knowledge base of adversary tactics and techniques used in cyber-attacks. It provides a common language and structure for describing and analyzing cyber threats and is used by security professionals, researchers, and organizations around the world. The framework includes information on various stages of an attack, from initial reconnaissance to the eventual impact on the target.",
      },
      {
        listText:
          "Each stage of the attack is broken down into specific tactics and techniques that an adversary may use. This information is derived from real-world observations and experiences and is intended to help organizations better understand the threat landscape and improve their security posture.",
      },
      {
        listText:
          "In addition to the main framework, MITRE also provides several resources to help organizations understand and implement the ATT&CK framework, including a matrix of techniques by platform, example use cases, and open- source tools for analyzing security events.",
      },
      {
        listText:
          "The MITRE ATT&CK framework describes the different stages of an attack by an adversary, which are:",
      },
    ],
    mitreDroplist2: [
      {
        num: "1. ",
        listHeading: "Reconnaissance: ",
        listText:
          "The attacker gathers information about the target system and its users, typically as part of preparation for initial access.",
      },
      {
        num: "2. ",
        listHeading: "Initial Access: ",
        listText: "The attacker gains entry into the target system or network.",
      },
      {
        num: "3. ",
        listHeading: "Execution: ",
        listText:
          "The attacker runs code on the target system, typically with the intention of establishing persistence and escalating privileges.",
      },
      {
        num: "4. ",
        listHeading: "Persistence: ",
        listText:
          "The attacker establishes mechanisms to maintain access to the target system, even after a reboot.",
      },
      {
        num: "5. ",
        listHeading: "Privilege Escalation: ",
        listText:
          "The attacker elevates their level of access to the target system, beyond what was obtained during initial access.",
      },
      {
        num: "6. ",
        listHeading: "Defense Evasion: ",
        listText:
          "The attacker takes steps to avoid detection and remain hidden on the target system.",
      },
      {
        num: "7. ",
        listHeading: "Credential Access: ",
        listText:
          "The attacker seeks to obtain passwords, hashes, and other means of authentication for use in further attacks.",
      },
      {
        num: "8. ",
        listHeading: "Discovery: ",
        listText:
          "The attacker seeks to gather information about the target system and its users, typically as part of preparation for lateral movement and data exfiltration.",
      },
      {
        num: "9. ",
        listHeading: "Lateral Movement: ",
        listText:
          "The attacker moves from their initial point of entry to other systems and networks within the target environment.",
      },
      {
        num: "10. ",
        listHeading: "Collection: ",
        listText:
          "The attacker exfiltrates data of interest from the target system.",
      },
      {
        num: "11. ",
        listHeading: "Command and Control: ",
        listText:
          "The attacker establishes and maintains communication with systems they have compromised.",
      },
      {
        num: "12. ",
        listHeading: "Exfiltration: ",
        listText: "The attacker removes data from the target environment.",
      },
      {
        num: "13. ",
        listHeading: "Impact: ",
        listText:
          "The attacker's actions cause harm to the target organization.",
      },
    ],
  },
  {
    heading:
      "How does Airgap Networks’ microsegmentation fit into this framework?",
    mitreDroplist: [
      {
        listText:
          "In a traditional network design, all devices and systems are connected to a single large network segment, which makes it easier for a malicious actor to move laterally within the network if they can breach a single system. Lateral movement refers to the process of an attacker moving from one compromised system to another to gain access to additional systems, data, and resources.",
      },
      {
        listText:
          "Airgap Networks’ microsegmentation fits into the MITRE ATT&CK framework as a mitigation technique for several tactics and techniques used by attackers. It involves dividing a network into smaller, isolated segments, with only authorized communication permitted between them. This helps to limit the scope and impact of a potential attack. By reducing the attack surface, Airgap Networks’ microsegmentation can prevent attackers from moving laterally within the network, making it more difficult for them to access sensitive data or systems. This can be particularly useful for countering tactics such as lateral movement and privilege escalation, which are often used in advanced persistent threat (APT) attacks.",
      },
      {
        listText:
          "Overall, network microsegmentation is a proactive security technique that helps organizations to prevent lateral movement within their networks, reduce the attack surface, and improve visibility into network activity.",
      },
    ],
  },
  {
    heading:
      "Examples of network microsegmentation preventing lateral movement",
    mitreDroplist: [
      {
        listText:
          "Here are a few examples of how network microsegmentation has helped prevent lateral movement:",
      },
    ],
    mitreDroplist2: [
      {
        listHeading: "Data center security: ",
        listText:
          "In a data center environment, microsegmentation can be used to isolate different parts of the network, such as web servers, database servers, and application servers. This helps to prevent lateral movement from one part of the network to another, even if a single system is compromised.",
      },
      {
        listHeading: "Healthcare environment: ",
        listText:
          "In a healthcare environment, microsegmentation can be used to isolate medical devices, such as pacemakers and insulin pumps, from the main network. This helps to prevent attackers from compromising the medical devices and moving laterally within the network.",
      },
      {
        listHeading: "Financial services: ",
        listText:
          "In the financial services sector, microsegmentation can be used to isolate critical systems, such as ATMs, from the main network. This helps to prevent attackers from compromising the ATMs and moving laterally within the network to reach other systems that may contain sensitive financial information.",
      },
      {
        listHeading: "Government agencies: ",
        listText:
          "In government agencies, microsegmentation can be used to isolate sensitive systems, such as classified networks, from the main network. This helps to prevent attackers from compromising sensitive systems and moving laterally within the network to reach other sensitive systems.",
      },
      {
        listText:
          "These are just a few examples of how network microsegmentation has been used to prevent lateral movement in different environments. The key point is that by dividing the network into smaller, isolated segments, network microsegmentation makes it much harder for attackers to move laterally within the network, and reduces the potential damage caused by a security breach.",
      },
    ],
  },
  {
    heading: "Summary",
    mitreDroplist: [
      {
        listText:
          "Network micro-segmentation helps organizations achieve compliance with the MITRE ATTACK framework by reducing the attack surface, isolating sensitive assets, and providing fine-grained access control. By dividing a network into smaller, isolated segments, it makes it harder for attackers to move laterally within a network and gain access to critical systems. Micro- segmentation helps organizations meet compliance requirements by reducing the risk of cyber-attacks and mitigating the impact of successful attacks, while also making it easier to monitor and control access to sensitive data.",
      },
    ],
  },
]

// Microsegmentation NIST CSF page
export const NISTCSF = [
  {
    heading: "Introduction",
    nistDroplist: [
      {
        listText:
          "The NIST Cybersecurity Framework (CSF) is a framework created by the National Institute of Standards and Technology (NIST) to help organizations improve their cybersecurity posture. It provides a common language and a structured approach to managing and reducing cybersecurity risk by defining a set of cybersecurity activities, outcomes, and references that align with business needs and industry standards. The NIST CSF is not a mandate or a one-size-fits-all solution, but rather a flexible framework that organizations can tailor and adopt to meet their specific needs.",
      },
    ],
  },
  {
    heading: "NIST Cybersecurity Framework",
    nistDroplist: [
      {
        listText:
          "The NIST CSF is a voluntary framework that provides a common language and a structured approach to managing and reducing cybersecurity risk. It is designed to help organizations align their cybersecurity efforts with their overall business goals and objectives.",
      },
      {
        listText:
          "The framework consists of five functions - Identify, Protect, Detect, Respond, and Recover - and outlines a set of activities, outcomes, and references for each function that organizations can use to assess and improve their cybersecurity posture. The NIST CSF is not prescriptive, meaning it does not dictate specific technologies or solutions that organizations must use. Instead, it provides a flexible and adaptable framework that organizations can tailor to their specific needs and risk profile.",
      },
      {
        listText:
          "The framework is designed to be used in conjunction with other existing standards, regulations, and best practices to help organizations effectively manage and reduce their cybersecurity risk.",
      },
      {
        listText: "The NIST CSF is organized into three categories:",
      },
    ],
    nistDroplist2: [
      {
        listHeading: "Framework Core: ",
        listText:
          "This includes the five functions and their associated activities, outcomes, and references. The Framework Core provides a consistent approach for organizations to manage and reduce their cybersecurity risk by guiding them through a structured process for identifying, protecting, detecting, responding to, and recovering from cybersecurity events.",
      },
      {
        listHeading: "Implementation Tiers: ",
        listText:
          "This categorizes an organization's level of cybersecurity maturity and risk management practices into four tiers: Partial, Risk Informed, Repeatable, and Adaptive. Organizations can use these tiers as a reference to assess their current posture and determine areas for improvement.",
      },
      {
        listHeading: "Profile: ",
        listText:
          "This is a customized version of the NIST CSF that aligns an organization's specific business requirements and risk tolerance with the activities and outcomes defined in the Framework Core. Organizations can use the Profile to prioritize their cybersecurity efforts, identify gaps in their current posture, and plan for future improvements.",
      },
      {
        listText:
          "The NIST CSF is regularly updated to reflect the evolving threat landscape and changing business needs, and organizations are encouraged to review and update their profiles regularly to maintain their cybersecurity posture. The framework is widely adopted by organizations in the public and private sector and is recognized as a best practice for managing cybersecurity risk.",
      },
    ],
  },
  {
    heading:
      "How does Airgap Networks microsegmentation fit into this framework?",
    nistDroplist: [
      {
        listText:
          "Network segmentation is an important aspect of cybersecurity and is incorporated into the NIST Cybersecurity Framework (CSF) as a best practice for reducing risk. Network segmentation refers to the process of dividing a computer network into smaller, separate networks to limit the spread of a potential security breach.",
      },
      {
        listText:
          "In the NIST CSF, network segmentation is associated with the Protect function, which focuses on reducing the risk of a cybersecurity event by implementing appropriate safeguards.",
      },
      {
        listText:
          "The Protect function of the NIST Cybersecurity Framework (CSF) is focused on reducing the risk of a cybersecurity event by implementing appropriate safeguards. The objective of the Protect function is to ensure that critical assets and sensitive information are protected against unauthorized access, disclosure, theft, or destruction.",
      },
      {
        listText: "The Protect function includes the following activities:",
      },
    ],
    nistDroplist2: [
      {
        listHeading: "Access control: ",
        listText:
          "This involves controlling access to critical assets and sensitive information by identifying, authenticating, and authorizing users and devices.",
      },
      {
        listHeading: "Maintenance: ",
        listText:
          "This involves regularly updating and patching systems and applications to prevent vulnerabilities from being exploited.",
      },
      {
        listHeading: "Data protection: ",
        listText:
          "This involves protecting sensitive information by encrypting data in transit and at rest, and by implementing data backup and recovery strategies.",
      },
      {
        listHeading: "Awareness and training: ",
        listText:
          "This involve educating and training employees on cybersecurity policies and procedures to help prevent human error from contributing to a cybersecurity event.",
      },
      {
        listHeading: "Protective technology: ",
        listText:
          "This involves implementing technical controls such as firewalls, intrusion detection systems, and security information and event management (SIEM) systems to detect and respond to potential security threats.",
      },
      {
        listText:
          "The Protect function of the NIST CSF is designed to help organizations reduce their risk of a cybersecurity event by implementing appropriate safeguards to protect critical assets and sensitive information. By following the activities and outcomes defined in the Protect function, organizations can ensure that they have implemented a comprehensive set of security controls to reduce their risk of a cybersecurity event.",
      },
      {
        listText:
          "The framework recommends that organizations implement network segmentation as a means of limiting the exposure of critical assets and sensitive data, and to help control the flow of information within the network.",
      },
      {
        listText:
          "By dividing a network into smaller segments, organizations can reduce the attack surface and limit the impact of a potential security breach. Network segmentation also enables organizations to implement different security policies for different segments of their network, depending on the level of security required for each segment. This helps to ensure that sensitive data and critical assets are protected, while still allowing users to access the resources they need to perform their jobs.",
      },
      {
        listText:
          "In summary, network segmentation is a key component of the NIST CSF and is recommended as a best practice for reducing cybersecurity risk by limiting the exposure of critical assets and sensitive data.",
      },
      {
        listText:
          "Airgap Networks’ agentless microsegmentation places each endpoint into its own isolated network segment and allows only authorized communication between them. The default security policy is to disallow any communication between each endpoint/network micro segment unless authorized by the security operator.",
      },
    ],
  },
  {
    heading: "Summary",
    nistDroplist: [
      {
        listText:
          "Network segmentation can help organizations comply with the NIST Cybersecurity Framework (CSF) by reducing the risk of a cybersecurity event and limiting the exposure of critical assets and sensitive information. By dividing a network into smaller, separate segments, organizations can reduce the attack surface and limit the spread of a potential security breach, while also enabling the implementation of different security policies for different segments of the network. Network segmentation is therefore an important aspect of the Protect function of the NIST CSF and is recommended as a best practice for reducing cybersecurity risk.",
      },
      {
        listText:
          "Microsegmentation is an integral part of Airgap’s Zero Trust Everywhere solution, contributing to our customers' zero trust security initiatives and frameworks.",
      },
    ],
  },
]

// Microsegmentation Cyber Insurance page
export const cyberInsurance = [
  {
    heading: "Introduction",
    cyberInsuranceDroplist: [
      {
        listText:
          "Cyber insurance is a type of insurance product that helps protect businesses and individuals from losses caused by various cyber risks such as data breaches, cyber-attacks, and other similar events. It can help cover the costs of responding to a cyber incident, such as the cost of notification and credit monitoring services for affected individuals, public relations expenses, and legal fees.",
      },
      {
        listText:
          "Additionally, cyber insurance can help cover the cost of restoring data and systems, as well as losses resulting from lost income or extra expenses incurred because of a cyber incident. Cyber insurance policies may also provide coverage for liability claims arising from a cyber event, such as a data breach that results in the unauthorized release of sensitive information.",
      },
      {
        listText:
          "Cyber insurance is an important consideration for any organization or individual that stores sensitive information electronically, as the costs of a cyber incident can be significant and potentially damaging to one's reputation and financial stability.",
      },
    ],
  },
  {
    heading: "Cyber Insurance",
    cyberInsuranceDroplist: [
      {
        listText:
          "Cyber insurance is a type of insurance policy designed to protect against losses related to cyber incidents such as data breaches, cyber-attacks, and network outages. It is designed to provide financial protection against the costs associated with responding to and recovering from a cyber event.",
      },
      {
        listText:
          "Some common types of coverage provided by cyber insurance policies include:",
      },
    ],
    cyberInsuranceDroplist2: [
      {
        listHeading: "Data breach response costs: ",
        listText:
          "This coverage helps to pay for the expenses associated with responding to a data breach, such as notifying affected individuals, providing credit monitoring services, and retaining legal and public relations consultants.",
      },
      {
        listHeading: "Cyber extortion: ",
        listText:
          "This coverage provides financial protection against the costs of responding to a ransomware attack or other type of cyber extortion attempt.",
      },
      {
        listHeading: "Business interruption: ",
        listText:
          "This coverage provides compensation for lost income and extra expenses incurred because of a network outage or other type of cyber incident that disrupts business operations.",
      },
      {
        listHeading: "Network security liability: ",
        listText:
          "This coverage provides protection against liability claims arising from a data breach or other type of cyber incident.",
      },
      {
        listHeading: "Electronic data restoration: ",
        listText:
          "This coverage helps to pay for the cost of restoring data that has been lost or damaged because of a cyber incident.",
      },
    ],
    text:
      "Cyber insurance policies can vary greatly in terms of coverage limits, exclusions, and deductibles, so it is important to carefully review the terms and conditions of any policy before purchasing. Additionally, it is important to regularly assess the changing cyber risks facing your organization or individual and make any necessary changes to your cyber insurance coverage to ensure that you are properly protected.",
  },
  {
    heading:
      "How does Airgap Networks’ microsegmentation fit into this framework?",
    cyberInsuranceDroplist: [
      {
        listText:
          "Network microsegmentation is a security technique that involves dividing a network into smaller segments, or micro-segments, to help reduce the attack surface and limit the potential impact of a breach. By reducing the number of access points and minimizing the number of systems and data that can be impacted in the event of a breach, network microsegmentation can help organizations minimize their exposure to cyber risks and increase their overall security posture.",
      },
      {
        listText:
          "By implementing network microsegmentation, organizations can demonstrate to cyber insurance providers that they have taken steps to reduce their risk and mitigate the potential impact of a breach. This can make them more attractive to insurance providers and potentially result in lower insurance premiums or better coverage terms.",
      },
      {
        listText:
          "However, it is important to note that network microsegmentation is just one component of a comprehensive cyber security strategy and that organizations should also implement other security measures, such as regular vulnerability scans, incident response planning, and employee training, to reduce their overall risk profile.",
      },
      {
        listText:
          "Ultimately, the benefits of network microsegmentation in terms of cyber insurance will depend on the specific requirements and risk assessment methods of individual insurance providers, so it is important for organizations to consult with their insurance providers to determine the best approach for their specific needs.",
      },
      {
        listText:
          "Airgap Networks’ agentless microsegmentation places each endpoint into its own isolated network segment and allows only authorized communication between them. The default security policy is to disallow any communication between each endpoint/network micro segment unless authorized by the security operator. In this way, servers and endpoints which are processing sensitive information can be placed in their own isolated network segments and only authorized communication permitted between them.",
      },
    ],
  },
  {
    heading: "Summary",
    cyberInsuranceDroplist: [
      {
        listText:
          "Network microsegmentation is a technique that involves dividing a network into smaller segments to reduce the attack surface and limit the potential impact of a breach. By implementing network microsegmentation, organizations can show their cyber insurance providers that they have taken steps to reduce their risk and increase their security posture, potentially leading to lower insurance premiums or better coverage terms.",
      },
      {
        listText:
          "However, network microsegmentation is just one component of a comprehensive cyber security strategy and organizations should also implement other security measures to further reduce their overall risk profile. The impact of network microsegmentation on cyber insurance will depend on the specific requirements and risk assessment methods of individual insurance providers.",
      },
      {
        listText:
          "Microsegmentation is an integral part of Airgap’s Zero Trust Everywhere solution, contributing to our customers' zero trust security initiatives and frameworks.",
      },
    ],
  },
]

// Navbar
export const NavbarData = [
  {
    pageName: "Solutions",
    link: "",
    dropdownData: [
      {
        name: "Secure Access",
        link: "/disposable-jump-box/",
      },
      {
        name: "Segmentation",
        link: "/ransomware-kill-switch/",
      },
      {
        name: "Discovery & Visibility",
        link: "/discovery-and-visibility/",
      },
      {
        name: "Network AI",
        link: "/network-ai/",
      },
    ],
  },
  {
    pageName: "Resources",
    link: "",
    dropdownData: [
      {
        name: "Blog",
        link: "/blog",
      },
      {
        name: "Solution Briefs",
        link: "/resources/#solutionBrief",
      },
      {
        name: "Case Studies",
        link: "/resources/#caseStudy",
      },
      {
        name: "Videos",
        link: "/resources/#videos",
      },
      {
        name: "Webinars",
        link: "/resources/#webinars",
      },
      {
        name: "Compliance",
        dropdownData2: [
          {
            name: "FedRamp",
            link: "/microsegmentation-fedramp",
          },
          {
            name: "HIPAA",
            link: "/microsegmentation-hipaa",
          },
          {
            name: "NIST CSF",
            link: "/microsegmentation-nist-csf",
          },
          {
            name: "FISMA",
            link: "/microsegmentation-fisma",
          },
          {
            name: "ISO 27001",
            link: "/microsegmentation-iso-27001",
          },
          {
            name: "PCI",
            link: "/microsegmentation-pci",
          },
          {
            name: "GDPR",
            link: "/microsegmentation-gdpr",
          },
          {
            name: "MITRE",
            link: "/microsegmentation-mitre",
          },
          {
            name: "Cyber Insurance",
            link: "/microsegmentation-cyber-insurance",
          },
        ],
      },
    ],
  },
  {
    pageName: "Company",
    link: "",
    dropdownData: [
      {
        name: "About Airgap",
        link: "/about",
      },
      {
        name: "Become a Partner",
        link: "/partners",
      },
      {
        name: "Deal Registration",
        link: "/business-deal-registration",
      },
      {
        name: "In the News",
        link: "/news-room",
      },
      {
        name: "Careers",
        link: "/careers",
      },
      {
        name: "Contact Us",
        link: "/contact-us",
      },
    ],
  },
]

// Company Logos
export const compnayImages = [
  { logo: Compnay10, alt: "Flex company logo" },
  { logo: Compnay9, alt: "Kingston company logo" },
  { logo: Compnay11, alt: "Dropbox company logo" },
  { logo: Compnay6, alt: "Tillys company logo" },
  { logo: Compnay3, alt: "UCAL Systems Inc company logo" },
  { logo: Compnay4, alt: "Skyline Enterprises company logo" },
  { logo: Compnay1, alt: "KCAS Bio Analytical Services company logo" },
  { logo: Compnay7, alt: "awfis company logo" },
]

// About page
export const LeaderShip = [
  {
    name: "Ritesh Agrawal",
    role: "CEO AND CO-FOUNDER",
    link: "https://www.linkedin.com/in/helloritesh/",
  },
  {
    name: "Vinay Adavi",
    role: "CPO and CO-FOUNDER",
    link: "https://www.linkedin.com/in/vinayadavi/",
  },
  {
    name: "Satish Mohan",
    role: "CTO AND CO-FOUNDER",
    link: "https://www.linkedin.com/in/satish-mohan/",
  },
]
export const Investors = [
  {
    logo: engineeringCapital,
  },
  {
    logo: cervin,
  },
  {
    logo: sorenson,
  },
  {
    logo: aspenwood,
  },
  {
    logo: storm,
  },
]
export const News = [
  {
    title: "PRESS RELEASE",
    heading: " Airgap Networks Acquires NetSpyGlass ",
    link: "/airgap-networks-acquires-netspyglass",
  },
  {
    title: "In the News",
    heading:
      " How Airgap CEO Ritesh Agrawal created an innovative cybersecurity startup ",
    link:
      "https://venturebeat.com/security/venturebeat-qa-how-airgap-ceo-ritesh-agrawal-created-an-innovative-cybersecurity-startup/",
  },
  {
    title: "PRESS RELEASE",
    heading:
      " Airgap Networks Named Winner of Three Coveted Global InfoSec Awards during RSA Conference 2023 ",
    link:
      "/airgap-networks-named-winner-of-three-coveted-global-infosec-awards-during-rsa-conference-2023/",
  },
  {
    title: "In the News",
    heading: "The top 20 zero-trust startups to watch in 2023 ",
    link:
      "https://venturebeat.com/security/the-top-20-zero-trust-startups-to-watch-in-2023/",
  },
  {
    title: "In the News",
    heading: "How zero trust can help secure complex OT: Expert Interview ",
    link:
      "https://www.industrialcybersecuritypulse.com/threats-vulnerabilities/how-zero-trust-can-help-secure-complex-ot-expert-interview-series-ritesh-agrawal-airgap-networks/",
  },
  {
    title: "PRESS RELEASE",
    heading: " Airgap Networks Achieves SOC 2 Type II Compliance ",
    link: "/SOC2-Compliance",
  },
  {
    title: "In the News",
    heading: "Three Companies To Watch In Cybersecurity ",
    link:
      "https://www.forbes.com/sites/moorinsights/2021/08/06/three-companies-to-watch-in-cybersecurity/",
  },
  {
    title: "PRESS RELEASE",
    heading: "Airgap Networks Raises $13 Million for Ransomware Kill Switch ",
    link: "/Series-A-Cervin-Blog",
  },
]
export const upcomingEvents = [
  {
    date: "WEBINAR",
    heading: "5 New Ways to Close the Enterprise Identity Gap",
    text: "In this highly interactive webcast and live demonstration, Jeff McDaniel, principal security engineer with Airgap, will show how easy it is to close the gap between access and identity for OT.",
    linkText: "Read more",
    link: "https://event.webcasts.com/starthere.jsp?ei=1643596&tp_key=00d4d820d1&sti=airgap",
  },
]
export const CEOBlogCard = [
  {
    title: "Ritesh Agrawal",
    heading: "CEO, Airgap Networks Inc.",
    link: "",
  },
  {
    title: "CEO BLOG SERIES",
    heading: "Why Microsegmentation is Core to Endpoint Security in 2023",
    link: "/microsegmentation-and-endpoint-security",
  },
  {
    title: "CEO BLOG SERIES",
    heading:
      "Ten Predictions on the Future of Zero Trust and Microsegmentation in 2023",
    link: "/zero-trust-predictions-2023",
  },
  {
    title: "CEO BLOG SERIES",
    heading:
      "Building a Business Case for Microsegmentation Part III: Securing OT & IoMT Networks",
    link: "/securing-ot-iomt-networks",
  },
]

// Resources page
export const SolutionBriefs = [
  {
    title: "SOLUTION BRIEF",
    heading: "Airgap Zero Trust Enterprise",
    text:
      "Shrink attack surface, lower costs, and improve business uptime with Airgap managed SaaS..",
    link: LogoZerotrustPdf,
    img: LogoZerotrust,
  },
  {
    title: "SOLUTION BRIEF",
    heading: "Disposable Jump Box",
    text:
      "Prevent threat proliferation from users to machines. Enforce identity-based restricted access.",
    link: dsjPdf,
    img: LogoDsj,
  },
  {
    title: "SOLUTION BRIEF",
    heading: "Ransomware Kill Switch",
    text:
      "Airgap’s Ransomware Kill Switch is the most potent ransomware response for the IT organization. Stop Ransomware before the spread.",
    link: Ransomware,
    img: Logo3,
  },
  {
    title: "SOLUTION BRIEF",
    heading: "Discovery and Visibility",
    text:
      "Real-time accuracy for all assets with full east-west visibility.",
    link: DiscoveryVisibility,
    img: LogoDiscovery,
  },
  {
    title: "SOLUTION BRIEF",
    heading: "Network AI - Network Performance and Intelligence",
    text:
      "Optimize network performance at scale, with precise KPI tracking and an intuitive interface.",
    link: networkAiPdf,
    img: LogoNetAi,
  },
]
export const CaseStudy = [
  {
    title: "CASE STUDY",
    heading: "FLEX",
    text:
      "Flex is a global supply chain & manufacturing solutions provider and is the third largest among global electronics manufacturers",
    link: "",
    link2: "/case-study",
    img: flexCaseStudyLogo,
    linkText: "Watch Video Case Study",
    modalId: "flexcasestudy",
  },
  {
    title: "CASE STUDY",
    heading: "KCAS Bioanalytical & Biomarker Services",
    text:
      "KCAS  is a rapidly growing company that provides comprehensive GLP / GCP compliant development services from early discovery support through product registration and beyond.",
    link: HealthcareIndustry,
    link2: "/case-study",
    img: KcasLogo,
    linkText: "Watch Video Case Study",
    modalId: "kcascasestudy",
  },
  {
    title: "case study",
    heading: "Tillys",
    text:
      "Tillys is a leading specialty retailer of casual apparel, footwear and accessories for young men, young women, boys and girls with an extensive assortment of iconic global, emerging.",
    link: tillysPdf,
    link2: "/case-study",
    img: Logo5,
    linkText: "Read Case study",
  },
  {
    title: "case study",
    heading: "SkyLine",
    text:
      "Skyline Enterprises is rapidly growing. Currently the core team is composed of 300 employees plus numerous outsourced contractors. Deepak Lathker, VP and head of IT, Security and Apps.",
    link: AcctonPdf,
    link2: "/case-study",
    img: Logo6,
    linkText: "Read Case study",
  },
  {
    title: "case study",
    heading: "Global cloud storage and SAAS collaboration tool",
    text:
      "Our customer, one of the largest cloud storage and collaboration tools companies in the world, with 500 million users around the world.",
    link: GlobalCloudPdf,
    link2: "/case-study",
    img: logo9,
    linkText: "Read Case study",
  },
  {
    title: "case study",
    heading: "Global clothing and accessories retailer",
    text:
      "Our customer, one of the largest retail chains in the world, with over $16 billion in revenue in 2019 with over 30,000 devices automated at 1000+ locations.",
    link: GlobalClothingPdf,
    link2: "/case-study",
    img: logo10,
    linkText: "Read Case study",
  },

]

export const onDemandWebinars = [
  {
    title: "Webinar",
    heading: "Detect, Defend, Deny",
    text: "Watch Dr. Chase Cunningham and Jeff McDaniel provide a compact and practical guide to elevating your OT cybersecurity through industry best practices.",
    link: "https://go.airgap.io/on-demand-webinar-detect-defend-deny",
    link2: "/case-study",
    img: flexCaseStudyLogo,
    linkText: "Watch Webinar",
  },
  {
    title: "Webinar",
    heading: "Simplified Zero Trust for OT",
    text: "Watch Dr. Chase Cunningham and Mike Wagner for this interactive webinar on simplified zero trust for OT.",
    link: "https://go.airgap.io/on-demand-webinar-simplified-zero-trust-for-ot",
    link2: "/case-study",
    img: flexCaseStudyLogo,
    linkText: "Watch Webinar",
  },
  {
    title: "Webinar",
    heading: "Faster Zero Trust Microsegmentation for IT/OT/IoMT",
    text: "Join Dr. Chase Cunningham and Mike Wager for cutting edge approaches to faster Zero Trust deployments for your OT/IoMT network.",
    link: "https://go.airgap.io/on-demand-webinar-faster-zt-microsegmentation",
    link2: "/case-study",
    img: flexCaseStudyLogo,
    linkText: "Watch Webinar",
  },
  {
    date: "WEBINAR",
    heading: "5 New Ways to Close the Enterprise Identity Gap",
    text: "In this highly interactive webcast and live demonstration, Jeff McDaniel, principal security engineer with Airgap, will show how easy it is to close the gap between access and identity for OT.",
    linkText: "Read more",
    link: "https://go.airgap.io/5-new-ways-to-close-the-enterprise-security-gap",
  },
]
export const CEOBlogs = [
  {
    cardlink: "/stopping-ransomware-in-its-tracks-with-innovative-vlan-defense/",
    img: BlogCard7,
    subtitle: "CEO BLOG SERIES",
    title: "Airgap Patent #9: Stopping Ransomware in Its Tracks with Innovative VLAN Defense",
    detailLink: "/stopping-ransomware-in-its-tracks-with-innovative-vlan-defense/",
  },
  {
    cardlink: "/microsegmentation-and-endpoint-security",
    img: BlogCard6,
    subtitle: "CEO BLOG SERIES",
    title: "Why Microsegmentation Is Core To Endpoint Security in 2023",
    detailLink: "/microsegmentation-and-endpoint-security",
  },
  {
    cardlink: "/zero-trust-predictions-2023",
    img: BlogCard4,
    subtitle: "CEO BLOG SERIES",
    title:
      "Ten Predictions on the future of Zero Trust and Microsegmentation in 2023",
    detailLink: "/zero-trust-predictions-2023",
  },
  {
    cardlink: "/securing-ot-iomt-networks",
    img: BlogCard3,
    subtitle: "CEO BLOG SERIES",
    title:
      "Building A Business Case for Microsegmentation Part ||: Securing OT & loMT Networks",
    detailLink: "/securing-ot-iomt-networks",
  },
  {
    cardlink: "/business-case-for-microsegmentation",
    img: BlogCard2,
    subtitle: "CEO BLOG SERIES",
    title:
      "Building A Business Case for Microsegmentation Part |: Put Zero Trust At The Core",
    detailLink: "/business-case-for-microsegmentation",
  },
  {
    cardlink: "/zero-trust-architecture-2023",
    img: BlogCard1,
    subtitle: "CEO BLOG SERIES",
    title:
      "Resolve To Get in Zero Trust Shape Starting With Microsegmentation In 2023",
    detailLink: "/zero-trust-architecture-2023",
  },
  {
    cardlink: "/zero-trust-microsegmentation-for-manufacturing",
    img: BlogCard5,
    subtitle: "CEO BLOG SERIES",
    title:
      "Why Manufacturers Need To Get Stronger at Zero Trust Starting with Microsegmentation",
    detailLink: "/zero-trust-microsegmentation-for-manufacturing",
  },
]

// Home page
export const NetSpyGlass = [
  {
    img: BannerLogo,
    title: "Airgap Networks Acquires NetSpyGlass",
    description:
      "Acquisition extends Airgap Zero Trust FirewallTM innovation leadership with advanced network and asset intelligence for business-critical networks",
    link: "/airgap-networks-acquires-netspyglass",
  },
]
export const Cards = [
  {
    img: Gartner,
    title: "Market Guide for Microsegmentation",
    text: "",
    btnText: "Read Now",
    link: "https://go.airgap.io/gartner-market-guide-microsegmentation",
  },
  {
    title: "Airgap Networks Acquires NetSpyGlass",
    text: "",
    btnText: "Learn More",
    link: "/airgap-networks-acquires-netspyglass",
    awardLogos: BannerLogo,
  },
  {
    img: "",
    title: "ThreatGPT TM",
    text: "Using AI to secure critical infrastructure",
    btnText: "Read More",
    link: "/threat-intelligence",
  },
]
export const SayCard = [
  {
    bgImage: SayImg1,
    linkName: "Defensible Manufacturing",
    cardLink: "/manufacturing",
  },
  // {
  //   bgImage: SayImg2,
  //   linkName: "Retail",
  //   cardLink: "/retail",
  // },
  {
    bgImage: SayImg3,
    linkName: "Defensible Healthcare",
    cardLink: "/healthcare",
  },
  {
    bgImage: SayImg4,
    linkName: "Defensible Transportation",
    cardLink: "/aviation",
  },
  {
    bgImage: SayImg5,
    linkName: "Defensible Energy",
    cardLink: "/energy",
  },
]
export const ResourceCard = [
  {
    img: Resource1,
    label: "CEO BLOG SERIES",
    heading: "Why Microsegmentation is Core to Endpoint Security in 2023",
    text: "",
    linkName: "See Details",
    cardLink: "/microsegmentation-and-endpoint-security",
  },
  {
    img: LogoDsj,
    label: "SOLUTION BRIEF",
    heading: "Disposable Jump Box",
    text: "",
    linkName: "Read Now",
    cardLink: dsjPdf,
    newTab: true,
  },
  {
    title: "SOLUTION BRIEF",
    heading: "Airgap Zero Trust Enterprise",
    text:
      "Shrink attack surface, lower costs, and improve business uptime with Airgap managed SaaS..",
    cardLink: LogoZerotrustPdf,
    img: LogoZerotrust,
    linkName: "Read Now",
    newTab: true,
  },
]
export const ThreatGPTDetection = [
  {
    img: UpdatedThreatGPT,
    threatDroplist: [
      {
        listNumber: "01",
        listText: "Detect and respond to advanced threats",
      },
      {
        listNumber: "02",
        listText: "Deep visibility into every OT traffic flow",
      },
      {
        listNumber: "03",
        listText: "Accurate, contextual anomaly detection",
      },
      {
        listNumber: "04",
        listText: "Natural language queries for fast, easy insights",
      },
    ],
    linkText: "LEARN MORE ABOUT THREAT GPT",
    link: "/threat-intelligence",
  },
]

// HomeUI Components
export const crCardData = [
  {
    id: 1,
    img: CustomerResultCard1,
    alt:"KCAS logo",
    title: "Agentless Segmentation logo",
    casestudy: HealthcareIndustry,
    casestudyButtonText: "Watch Case Study"
  },
  {
    id: 2,
    img: CustomerResultCard2,
    alt:"Skyline Emterprises logo",
    title: "Agentless Segmentation",
    casestudy: AcctonPdf,
    casestudyButtonText: "Read Case Study"
  },
]
export const otCardData = [
  {
    id: 1,
    link: "https://airgap-staging.netlify.app/solutions/manufacturing",
    title: "Manufacturing",
    img: OTCard1,
  },
  {
    id: 2,
    link: "https://airgap-staging.netlify.app/solutions/healthcare/",
    title: "Healthcare and Hospital",
    img: OTCard2,
  },
  {
    id: 2,
    link: "https://go.airgap.io/tillys-case-study",
    title: "Retail",
    img: OTCard3,
  },
]
export const stepData = [
  {
    id: 1,
    title: "STEP 1",
    img: StepImg1,
    heading: "Power On  airgap.io",
    subheading: "",
  },
  {
    id: 2,
    title: "STEP 2",
    img: StepImg2,
    heading: "Onboard Your VLAN",
    subheading: "",
  },
  {
    id: 4,
    title: "STEP 3",
    img: StepImg4,
    heading: "Verify Traffic Between Devices",
    subheading: "",
  },
  {
    id: 5,
    title: "STEP 4",
    img: StepImg5,
    heading: "Activate Ransomware Kill Switch",
    subheading: "",
  },
]

// Platform page
export const platformCard = [
  {
    img: icon1,
    title: "Agentless Microsegmentation",
    text:
      "Perfectly segment what agent-based solutions can’t, from ICS to MRI machines to legacy platforms and IoT",
  },
  {
    img: icon2,
    title: "Secure Access for Critical Assets",
    text:
      "Protect critical assets with MFA, including legacy devices and old Windows machines",
  },
  {
    img: icon3,
    title: "Network and Asset Intelligence",
    text:
      "Actionable insights into asset health and security vulnerabilities, with ML-driven network threat & performance monitoring",
  },
]
export const OperationalCard = [
  {
    cardImg: Operational1,
    heading: "Up to 90% network attack surface reduction",
    para: "Point and click - Instant results.",
    link: "/disposable-jump-box/"
  },
  {
    cardImg: Operational3,
    heading: "Ransomware Kill Switch™",
    para: "Hard stop containment",
    link: "/ransomware-kill-switch/"
  },
  {
    cardImg: Operational2,
    heading: "ThreatGPT",
    para: "Threat Intelligence, the ChatGPT way!",
    link: "/discovery-and-visibility/"
  },

]
export const Compliance = [
  {
    logo: Compliance1,
    link: "/microsegmentation-fedramp/"
  },
  {
    logo: Compliance2,
    link: "/microsegmentation-hipaa/"
  },
  {
    logo: Compliance3,
    link: "/microsegmentation-nist-csf"
  },
  {
    logo: Compliance4,
    link: "/microsegmentation-fisma"
  },
  {
    logo: Compliance5,
    link: "/microsegmentation-iso-27001"
  },
  {
    logo: Compliance6,
    link: "/microsegmentation-pci"
  },
  {
    logo: Compliance7,
    link: "/microsegmentation-gdpr"
  },
  {
    logo: Compliance8,
    link: "/microsegmentation-mitre"
  },
]

// Agentless Microsegmentation page
export const MicrosegmentCard = [
  {
    img: logo1,
    title: "Microsegment",
    text:
      "Full traffic visibility for all network devices, intra-VLAN and inter-VLANT",
  },
  {
    img: logo2,
    title: "Visible",
    text:
      "Protect critical assets with MFA, including legacy devices and old Windows machines",
  },
  {
    img: logo3,
    title: "Seamless",
    text: "No agents, forced hardware upgrades or major network changes",
  },
  {
    img: logo4,
    title: "Integrated",
    text:
      "Single solution for critical infrastructure with agentless microsegmentation, secure access, and asset intelligence",
  },
]

// Secure Access For Critical Assets page
export const AuthenticateCard = [
  {
    img: logo1,
    title: "Extend MFA",
    text: "Protect every type of asset with MFA, including legacy machines",
  },
  {
    img: logo2,
    title: "Partner-Friendly",
    text:
      "Ensure secure access for engineering partners and fully secured remote support",
  },
  {
    img: logo3,
    title: "Seamless",
    text: "Keep or replace existing VPN infrastructure to lower VPN sprawl",
  },
  {
    img: logo4,
    title: "Integrated",
    text:
      "Single solution for IT/OT with integrated microsegmentation, secure access, and incident response",
  },
]

// Asset Intelligence page
export const KnowCard = [
  {
    img: logo1,
    title: "Improve Uptime",
    text:
      "Proactively monitor the health of every network element and port with real-time granular telemetry analysis",
  },
  {
    img: logo2,
    title: "Enhance Security",
    text:
      "Easily identify potential threats and isolate compromised or at-risk devices",
  },
  {
    img: logo3,
    title: "Streamline Operations",
    text:
      "Reduce the time and effort required to maintain your network, improve troubleshooting, and ensure compliance",
  },
  {
    img: logo4,
    title: "Simplify Deployment",
    text:
      "Single solution for critical infrastructure with agentless microsegmentation, secure access, and asset intelligence",
  },
]

// Threat Intelligence page
export const ThreatGPTCard = [
  {
    img: logo1,
    title: "Detect and respond to advanced threats",
    text:
      "Perfectly microsegment what agent-based solutions can't, like hospital equipment, headless machines, and IoMT.",
  },
  {
    img: logo2,
    title: "Deep insights into every OT traffic flow",
    text:
      "ThreatGPT uses a combination of graph databases and GPT-3 models to provide powerful cybersecurity insights",
  },
  {
    img: logo3,
    title: "Accurate, contextual anomaly detection",
    text:
      "ThreatGPT easily integrates contextual information such as user identity and device type for accurate detection and fewer false positives",
  },
  {
    img: logo4,
    title: "Deep insights into every OT traffic flow",
    text:
      "Easily identify potential security vulnerabilities with minimal training. Ask questions in plain English for actionable insights.",
  },
]
export const detailCard = [
  {
    img: UpdatedThreatGPT,
    title: "Enhanced threat detection and response",
    text:
      "Take full advantage of Airgap’s visibility into every OT traffic flow. Quickly identify potential vulnerabilities in your OT networks and take proactive measures to prevent security incidents. Fully integrated with Airgap Agentless Microsegmentation for detection and enforcement.",
  },
  {
    img: section6,
    title: "Create security policies with ease",
    text:
      "Airgap ThreatGPT enables security operators to create security policies for organizations using plain English. With natural language queries, security operators can create policies more efficiently without requiring complex syntax or programming languages.",
  },
  {
    img: section7,
    title: "Integrated AI and ML threat detection and response",
    text:
      "ThreatGPT is fully integrated into the Airgap threat intelligence suite. Granularly block communication to or from any endpoint when under attack with minimum impact to business continuity. AI/ML monitoring, pattern recognition, and alerts for early detection and effective response.",
  },
]

// Manufacturing page
export const IntelligenceDetail = [
  {
    img: hsptlsection6,
    dropList: [
      {
        title: "DISCOVER",
        list:
          "Comprehensive discovery and visibility for every connected device",
      },
      {
        title: "DETECT",
        list:
          "AI and ML-driven threat detection for early warning of anomalous traffic patterns",
      },
      {
        title: "RESPOND",
        list:
          "Take instant action and lock down traffic to or from any device for granular containment",
      },
    ],
    heading: "Asset Intelligence for Critical Infrastructure",
    linkText: "LEARN MORE ABOUT ASSET INTELLIGENCE",
    link: "/asset-intelligence",
  },
  {
    img: hsptlsection7,
    dropList: [
      {
        title: "",
        list: "Detect and respond to advanced threats",
      },
      {
        title: "",
        list: "Deep insights into every traffic flow",
      },
      {
        title: "",
        list: "Accurate, contextual anomaly detection",
      },
      {
        title: "",
        list: "Natural language queries",
      },
    ],
    heading: "ThreatGPT™ for faster, deeper threat intelligence",
    linkText: "LEARN MORE ABOUT THREATGPT™",
    link: "/threat-intelligence",
  },
]

// Healthcare Page
export const HealthcareCard = [
  {
    img: icon1,
    title: "Agentless Microsegmentation",
    text:
      "Perfectly microsegment what agent-based solutions can't, like hospital equipment, headless machines, and IoMT.",
  },
  {
    img: icon2,
    title: "Secure Access for Critical Assets",
    text:
      "Protect critical assets with MFA, including legacy devices and old Windows machines",
  },
  {
    img: icon3,
    title: "Asset Intelligence",
    text:
      "Actionable insights into asset health and security vulnerabilities, with ML-driven network threat & performance monitoring",
  },
]

// Integration Page
export const IntegrationCard = [
  {
    img: Icon1,
    title: "SentinelOne",
    desc:
      "Advanced endpoint protection and threat intelligence solutions to detect and mitigate cybersecurity threats.",
  },
  {
    img: Icon2,
    title: "CrowdStrike",
    desc:
      "Cloud-based endpoint protection and threat intelligence services to dynamically detect and respond to cyber threats.",
  },
  {
    img: Icon3,
    title: "Splunk",
    desc:
      "Leading Security Information and Event Management (SIEM) platform that collects, analyses, and monitors security data to immediately identify and respond to security incidents.",
  },
  {
    img: Icon4,
    title: "ZScaler",
    desc:
      "Cloud-based security services, including secure web gateways and cloud application security to protect against internet threats and provide secure access to cloud resources.",
  },
  {
    img: Icon5,
    title: "Okta",
    desc:
      "Workforce Identity Cloud - Connect and protect your employees, contractors, and business partners with Identity-powered security",
  },
  {
    img: Icon6,
    title: "ELK",
    desc:
      "Open-source stack for centralized logging and log analysis that gathers, processes, and visualizes large volumes of data.",
  },
  {
    img: Icon7,
    title: "Armis",
    desc:
      "The Armis Asset Intelligence & Security Platform aggregates, deduplicates, normalizes asset data and provide an accurate inventory, uncover security gaps, and automate action.",
  },
  {
    img: Icon8,
    title: "PagerDuty",
    desc:
      "Incident management platform to manage and respond to critical network incidents immediately for efficient and reliable incident resolution.",
  },
  {
    img: Icon9,
    title: "ServiceNow",
    desc:
      "Cloud-based IT service management (ITSM) platform to automates workflows, streamlines operations, and improve service delivery.",
  },
  {
    img: Icon10,
    title: "Microsoft Entra",
    desc:
      "Azure Active Directory (Azure AD), part of Microsoft Entra, is an enterprise identity service that provides single sign-on, multifactor authentication, and conditional access to guard against 99.9 percent of cybersecurity attacks",
  },
  {
    img: Icon11,
    title: "OneLogin",
    desc:
      "Single Sign-On (SSO) solutions to allow seamless access to multiple applications with a single set of credentials",
  },
  {
    img: Icon12,
    title: "Azure AD",
    desc:
      "Single Sign-On (SSO) solutions to allow seamless access to multiple applications with a single set of credentials",
  },
]

export const PartnerCard = [
  {
    img: PartnerIcon1,
    title: "AWS",
  },
  {
    img: PartnerIcon2,
    title: "Azure",
  },
  {
    img: PartnerIcon3,
    title: "GCP",
  },
  {
    img: Icon6,
    title: "ELK",
  },
]

// Case Study Web Page
export const challengeSolution = [
  {
    title: "Challenges",
    dropList: [
      {
        list: "OT Devices across different buildings",
      },
      {
        list: "Distributed asset connectivity and core network setup",
      },
      {
        list: "Operational and network complexity",
      },
      {
        list: "Reducing the attack surface to minimize threats",
      },
      {
        list:
          "Agent based segmentation and edge firewall solutions disrupt processes of sensitive OT and ICS",
      },
    ],
  },
  {
    title: "Solutions",
    dropList: [
      {
        list:
          "Microsegmentation of the client Network with the deployment of the Airgap ZTMFTM in only one building",
      },
      {
        list: "Asset categorization for Zero trust based on minimum privileges",
      },
      {
        list: "Improved Asset Discovery and Visibility in the critical network",
      },
      {
        list: "Dynamic location and isolation of threats",
      },
      {
        list:
          "Light touch agentless solution to secure and segment each device on the critical network",
      },
    ],
  },
]

export const headlessMachine = [
  {
    dropList: [
      {
        list: "No network connectivity required",
      },
      {
        list:
          "Can communicate with the network but should not communicate with any other devices or systems on the network",
      },
      {
        list:
          "Connect to the manufacturing LAN and the internet for updates and downloads",
      },
      {
        list: "Connect to the network",
      },
      {
        list: "Communicate only with internal IT team network",
      },
      {
        list: "Connect to user endpoints",
      },
    ],
    img: MachineLogo,
  },
]

export const Result = [
  {
    img: Plus,
    text: "Secure network polices",
  },
  {
    img: Plus,
    text: "Mircrosegmentation of critical infrastructure",
  },
  {
    img: Plus,
    text: "Zero trust with minimum network privileges",
  },
]

export const highlightPara = [
  {
    para:
      "Mission critical OT devices, ICS, and headless machines communicating with the client’s core network are expressly vulnerable to threats.",
  },
  {
    para:
      "Airgap was first deployed to the client setup in the Southern California region to microsegment the mission critical OT devices and systems spread across LANs connected across 7 buildings.",
  },
]

// Case Study Web Page Hero Banner
export const WebPageHeroBanner = [
  {
    droplist: [
      {
        title: "Client",
      },
      {
        title: "Industry",
      },
      {
        title: "Priorities",
      },
      {
        title: "Solutions",
      },
    ],
  },
  {
    droplist: [
      {
        cols: ":",
      },
      {
        cols: ":",
      },
      {
        cols: ":",
      },
      {
        cols: ":",
      },
    ],
  },
  {
    droplist: [
      {
        text:
          "Global Leader in Manufacturing Devices and Solutions in the Storage and memory Space",
      },
      {
        text: "Manufacturing",
      },
      {
        text:
          "Zero Trust Network Security, microsegmentation of Critical Infrastructure on the network",
      },
      {
        text:
          "Airgap ZTFWTM | Network and Asset Intelligence | Privileged Access management",
      },
    ],
  },
]

export const newsData = [
  {
    month: "June 21, 2023",
    heading: "Airgap Networks Acquires NetSpyGlass",
    intro: "Acquisition of NetSpyGlass extends Airgap Zero Trust Firewall™ innovation leadership with advanced network and asset intelligence for business-critical networks",
    link: "/airgap-networks-acquires-netspyglass"
  },
  {
    month: "May 03, 2023",
    heading: "Airgap Networks Enhances Award-Winning Zero Trust Firewall with ThreatGPT to Protect Business-Critical Infrastructure with AI/ML Technologies",
    intro: "Airgap Networks announced today that it is bringing the power of cutting-edge AI to its award-winning Zero Trust Firewall™ with ThreatGPT™. Built on an advanced AI/ML model designed to protect enterprises from evolving cyber threats, ThreatGPT delivers a new level of insight and productivity for network security teams.",
    link: "/airgap-networks-enhances-award-winning-zero-trust-firewall-with-threatgpt-to-protect-business-critical-infrastructure-with-ai-ml-technologies/"
  },
  {
    month: "April 26, 2023",
    heading: "Airgap Networks Named Winner of Three Coveted Global InfoSec Awards during RSA Conference 2023",
    intro: "Airgap Wins Most Comprehensive Micro-Segmentation, Next Gen OT Security and Most Comprehensive Remote Work Security in 11th Annual Global InfoSec Awards at #RSAC 2023",
    link: "/airgap-networks-named-winner-of-three-coveted-global-infosec-awards-during-rsa-conference-2023/"
  },
  {
    month: "March 08, 2023",
    heading: "Airgap Networks Selected to Join 5G Open Innovation Lab Development Program, Extending Zero Trust Security to Private 5G",
    intro: "Airgap Networks, the innovation leader in Zero Trust security for OT, has formally joined the 5G Open Innovation Lab's ('5GOILab') Batch 7 Spring 2023 program",
    link: "/airgap-networks-selected-to-join-5g-open-innovation-lab-development-program-extending-zero-trust-security-to-private-5g/"
  },
  {
    month: "August 18, 2022",
    heading: "Airgap Networks Achieves SOC 2 Type II Compliance",
    intro: "Customer data security is at the core of how we operate at Airgap Networks. Last week, Airgap Networks passed the SOC2 Type II audit without exceptions",
    link: "/SOC2-Compliance/"
  },
  {
    month: "April 05, 2022",
    heading: "Airgap Networks Raises $13.4M in Series A Funding",
    intro: "Airgap Networks, the provider of the industry’s first Ransomware Kill Switch™, recently announced a $13.4 million Series A round of financing",
    link: "/Series-A-Cervin-Blog"
  }
]

export const newsRoomData = [
  {
    logo: networkWorld,
    logoWidth: "175px",
    heading: "Remote work keeps driving network innovation",
    intro: "Enterprises are seeking new ways to extend security across distributed environments that include IoT networks, mobile workforces, and multicloud deployments.",
    link: "https://www.networkworld.com/article/1312757/remote-work-continues-to-drive-network-innovation.html"
  },
  {
    logo: networkWorld,
    logoWidth: "175px",
    heading: "Security startup Airgap Networks brings telco technologies to the LAN",
    intro: "Airgap Networks has developed a ransomware kill switch that blocks all lateral device-to-device communications and disables network-level communications among workstations and applications.",
    link: "https://www.networkworld.com/article/957426/startup-airgap-networks-brings-telco-technologies-to-the-lan.html"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "5 ways CISOs can prepare for generative AI’s security challenges and opportunities",
      intro: "With generative AI tools like ChatGPT proliferating across enterprises, CISOs have to strike a very difficult balance: Performance gains versus unknown risks. Gen AI is delivering greater precision to cybersecurity but also being weaponized into new attack tools such as FraudGPT that advertise their ease of use for the next generation of attackers.",
      link: "https://venturebeat.com/security/5-ways-cisos-can-prepare-for-generative-ai-security-challenges-and-opportunities/"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "Honeywell’s acquisition of cybersecurity provider sets sights on manufacturing sector’s deep IoT vulnerabilities",
      intro: "The manufacturing sector is rife with unprotected Internet of Things (IoT) sensors and devices, many of them integrated into enterprises’ mission-critical systems. The resulting gaps make operations technology (OT) and information technology (IT) networks vulnerable to devastating cyberattacks.",
      link: "https://venturebeat.com/security/honeywell-acquisition-cybersecurity-provider-manufacturing-sector-iot-vulnerabilities/"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "How AI brings greater accuracy, speed, and scale to microsegmentation",
      intro: "Microsegmentation is table stakes for CISOs looking to gain the speed, scale and time-to-market advantages that multicloud tech stacks provide digital-first business initiatives.",
      link: "https://venturebeat.com/security/how-ai-brings-greater-accuracy-speed-and-scale-to-microsegmentation/"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "Designing for safety: 10 cybersecurity priorities for a zero-trust data center",
      intro: "Zero trust is the virtual shield data centers need to harden against increasingly complex, well-orchestrated data center attacks. Attackers are gaining access to data centers using stolen privileged access credentials and IDs, looking to exfiltrate as much customer data as possible.",
      link: "https://venturebeat.com/security/designing-for-trust-top-10-cybersecurity-priorities-for-cios-in-2023/"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "Why attackers love to target IoT devices",
      intro: "Lacking designed-in security and plagued with chronic default password use, Internet of Things (IOT) devices are quickly becoming attackers’ favorite targets. Add to that the rapid rise of the many different roles and identities assigned to each advanced IoT sensor in an operations technology (OT) network, and their proximity to mission-critical systems running a business, and it is no surprise attackers love to target IoT devices.",
      link: "https://venturebeat.com/security/why-attackers-love-to-target-iot-devices/"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "How Airgap CEO Ritesh Agrawal created an innovative cybersecurity startup",
      intro: "VentureBeat sat down (virtually) last week with Ritesh Agrawal, CEO and cofounder of Airgap Networks, to gain insights into how he and his team are creating one of the most innovative startups in the cybersecurity industry.",
      link: "https://venturebeat.com/security/venturebeat-qa-how-airgap-ceo-ritesh-agrawal-created-an-innovative-cybersecurity-startup/"
    },
  {
      logo: darkreadinglogo,
      logoWidth: "175px",
      heading: "New Generative AI Tools Aim to Improve Security",
      intro: "The debate over whether ChatGPT and other generative AI tools will benefit defenders or further embolden attackers may be ongoing, but companies are going forward with new tools.",
      link: "https://www.darkreading.com/emerging-tech/new-generative-ai-tools-aim-to-improve-security"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "10 ways ChatGPT and generative AI can strengthen zero trust",
      intro: "ChatGPT’s potential to improve cybersecurity and zero trust needs to start with the goal of learning from every breach attempt — and becoming stronger from it. Generative AI can deliver the greatest value in the shortest time when we look at it as a continuous learning engine that finds correlations, relationships and causal factors in threat data — and that never forgets. ChatGPT and generative AI can be used to create “muscle memory,” or immediate reflex, in cybersecurity teams to stop breaches.",
      link: "https://venturebeat.com/security/10-ways-chatgpt-and-generative-ai-can-strengthen-zero-trust/"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "The top 20 zero-trust startups to watch in 2023",
      intro: "For many zero-trust founders and their teams, their sales pipeline is now their financial lifeline. With venture funding cooling off in 2023, founders are re-evaluating and, in some cases, pushing back on the growth-at-all-costs mentality investors urged them to pursue just a few months ago.",
      link: "https://venturebeat.com/security/the-top-20-zero-trust-startups-to-watch-in-2023/",
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "Defending against backdoor attacks with zero trust",
      intro: "Attackers are doubling down on backdoor attacks that deliver ransomware and malware, proving that businesses need zero trust to secure their endpoints and identities.",
      link: "https://venturebeat.com/security/defending-against-backdoor-attacks-with-zero-trust/"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "A roadmap to zero-trust maturity: 6 key insights from Forrester",
      intro: "Once an enterprise decides to go all-in on zero trust, it usually starts strong, only to hit barriers no one saw coming. This makes a roadmap essential. Seeing its clients who are pursuing zero trust facing challenges in reaching the next level of maturity, Forrester invested a year of its zero trust team’s time in creating the roadmap they need. ",
      link: "https://venturebeat.com/security/roadmap-to-zero-trust-maturity-6-key-insights/"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "10 steps every business can take to avoid a cybersecurity breach",
      intro: "Businesses that survive cyberattacks understand that breaches are inevitable. That’s a strong motivator to make cyber-resilience and business recovery a core part of their DNA. CISOs and IT leaders tell VentureBeat that taking steps beforehand to be more resilient in the face of disruptive and damaging cyberattacks is what helped save their businesses. For many organizations, becoming more cyber-resilient starts with taking practical, pragmatic steps to avoid a breach interrupting operations.",
      link: "https://venturebeat.com/security/10-steps-every-business-can-take-to-avoid-a-cybersecurity-breach/4"
  },
  {
      logo: icnLogo,
      logoWidth: "40px",
      heading: "How zero trust can help secure complex OT",
      intro: "How can zero trust help protect critical infrastructure? It's not the only option, but it's an excellent solution for both information technology (IT) and operational technology (OT), said Ritesh Agrawal, CEO and co-founder at Airgap Networks.",
      link: "https://www.industrialcybersecuritypulse.com/threats-vulnerabilities/how-zero-trust-can-help-secure-complex-ot-expert-interview-series-ritesh-agrawal-airgap-networks/",
    },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "Getting results from your zero-trust initiatives in 2023",
      intro: "CISOs today find their agendas dominated by the need to reduce the complexity and costs of securing multicloud infrastructure while consolidating tech stacks to save on costs and increase visibility. That makes zero trust a priority. Seventy-five percent of security leaders say their cybersecurity systems and tech stacks are too complex and costly to operate. That’s why CISOs are relying more and more on zero-trust initiatives to simplify and strengthen their enterprises’ cybersecurity postures and secure every identity and endpoint.",
      link: "https://venturebeat.com/security/getting-results-from-your-zero-trust-initiatives-in-2023/"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "How AI can help close IoT’s growing security gaps to contain ransomware",
      intro: "Nation-state attackers are fine-tuning their tradecraft to take advantage of unprotected IoT sensors essential to infrastructure and manufacturing and increasing their attacks against U.S. and European targets. Once-sporadic attacks have given way to an all-out assault on infrastructure and production plants.",
      link: "https://venturebeat.com/security/how-ai-can-help-close-iots-growing-security-gaps-to-contain-ransomware/"
  },
  {
      logo: ventureBeatLogo,
      logoWidth: "175px",
      heading: "Why CISOs need zero trust as a ransomware shield",
      intro: "Zero trust security needs to be a mindset that pervades everything from consolidating tech stacks to managing identities at scale. CISOs and their teams must start with the assumption that a breach has already happened, and an organization’s network needs to be designed to limit an intrusion’s blast radius and depth.",
      link: "https://venturebeat.com/security/why-cisos-need-zero-trust-as-a-ransomware-shield/"
  },
  {
      logo: forbesLogo,
      logoWidth: "100px",
      heading: "Three Companies To Watch In Cybersecurity",
      intro: "At Black Hat USA 2021 this week, Airgap launched the general availability of its security platform after approximately one and a half years of product development",
      link: "https://www.forbes.com/sites/moorinsights/2021/08/06/three-companies-to-watch-in-cybersecurity/?sh=3ca495bb7c6a"
    }
]
export const videoResources = [
  {
    tag: "RESOURCE HIGHLIGHT",
    videoUrl: ceoInterviewUrl,
    thumbnailUrlKey: "ceo",
    videoHeading: "Airgap CEO interview at RSAC",
    videoDescription:`Hybrid work is our new norm with apps, devices and users are now
                      everywhere and anywhere accessing critical infrastructure and
                      business crown jewels. This shift dramatically increases the
                      attack surface. Old legacy security cannot address modern
                      security challenges. It's time to deploy single unified
                      zero-trust access policy and security enforcement with
                      continuous trust verification`,
    pointer: "ceoInterview"
  },
  {
    tag: "CUSTOMER HIGHLIGHT",
    videoUrl: FlexVideoUrl,
    thumbnailUrlKey: "",
    videoHeading: "FLEX",
    videoDescription:`Hear from the Business Information Security Officer who shares how they shrank attack surface with Airgap 
                      and improved compliance and safety of operations.`,
    pointer: "AirgapFlexCasestudy"
  },
  {
    tag: "CUSTOMER HIGHLIGHT",
    videoUrl: tillysVideo,
    thumbnailUrlKey: "tillys",
    videoHeading: "TILLYS",
    videoDescription:`Hear from the Director of Information Security & Compliance who shares how quick the implementation 
                      was and the benefits of having a partner like Airgap.`,
    pointer: "AirgapTillysCasestudy"
  },
]
